/* eslint-disable max-len */
import links from "app/core/resource/links";

export default {
    main: {
        title: "Про компанію",
        description: `<p>
                    Електронна медична інформаційна система apteka24.ua співпрацює з кількома сотнями аптеками-партнерами, завдяки яким клієнти отримують можливість бронювання ліків з полиці найближчої аптеки.
                </p>

                <p>
                            Замовляючи ліки та товари медичного призначення через електронну медичну інформаційну систему apteka24.ua, ви:
                        </p>

                        <ul>
                            <li>
                                знаходите на сайті лікарський засіб, якого немає у багатьох аптеках;
                            </li>

                            <li>
                                в один клік бронюєте товар;
                            </li>

                            <li>
                                забираєте його в аптеці, яка до вас найближча;
                            </li>

                            <li>
                                можете отримати кур'єрську доставку на адресу.
                            </li>
                        </ul>

                <p>
                    Крім того, сайт apteka24.ua — це портал освітнього формату з інформацією про медицину, лікарські препарати, а також про здоров'я та добробут як такі. Ми, в apteka24.ua, надаємо користувачам можливість ознайомитися з великими медичними даними з питань здоров'я та застосування лікарських засобів. Для нас дуже важливо бути джерелом надійної, достовірної та науково доведеної інформації, яка була б корисна людям і допомагала б викорінити плутанину та дезінформацію в медичній сфері.
                </p>`,
        keyFactsAboutUs: `Ключові факти про нас`,
        vision: `<h3>Бачення</h3>

                <p>
                    Ламати стереотипи аптечного бізнесу.
                </p>`,
        mission: `<h3>Місія</h3>

                <p>
                    Ми прагнемо дати клієнтам сервіс та знання, необхідні для більш ефективного управління своїм власним здоров'ям, а також підвищувати безпеку лікування, допомагаючи пацієнтам скоротити кількість помилок при застосуванні ліків.
                </p>`,
        worth: `<h3>Цінності</h3>

                <p>
                    Наші цінності: відкритість, достовірність, залученість і гарантії якості.
                </p>`,
        openness: `<p>
                        <strong>
                            Відкритість
                        </strong>
                    </p>

                    <p>
                        Прозорість — один з основних наших принципів, адже саме на ньому будується довіра. Ми відкрито говоримо про хитрощі, до яких вдаються в аптечній сфері, або про те, чому брендові ліки не гірші дженериків.
                    </p>

                    <p>
                        Все, що ми робимо — прозоро. Тому ми самі відкрито заявляємо про джерела нашого фінансування, демонструємо всі наші сертифікати і ліцензії, а також попереджаємо про можливий конфлікт інтересів там, де він може вплинути на вас.
                    </p>`,
        reliability: `<p>
                        <strong>
                            Достовірність
                        </strong>
                    </p>

                    <p>
                        Наш основний принцип — повідомляти тільки науково доведену інформацію. Сьогодні інтернет рясніє спотвореною або невідповідною дійсності інформацією про медицину, а більшість сайтів про здоров'я заповнюють маркетологи, які не замислюються про якість і достовірність наданих медичних даних. До того ж, в медицині постійно відбуваються зміни і нові відкриття, однак більшість інформаційних ресурсів не стежать за актуальністю інформації. Це призводить до того, що люди читають недостовірні або застарілі статті, якими керуються при лікуванні хвороб. Зростає ризик помилок під час застосування лікарських засобів.
                    </p>

                    <p>
                        Ми підтримуємо свідому медицину, тому надаємо достовірну інформацію, що проходить кілька етапів перевірки: починаючи від пошуку офіційних джерел і закінчуючи перевіркою фактів медичним експертом. Детальніше про процес верифікації матеріалів ви можете дізнатися з нашої&nbsp;
                        <a target="_blank" href="${links.editorialPolicy}">
                            редакційної політики.
                        </a>
                    </p>

                    <p>
                        Інструкції до препаратів ми публікуємо відповідно до&nbsp;
                        <a target="_blank" href="${links.stateRegisterOfDrugs}">Державного реєстру лікарських засобів України.</a>
                        &nbsp;Але не обмежуємося цим. Ми розуміємо, що інструкції в більшості випадків незрозумілі багатьом людям, тому ознайомленням з ними нехтують. У зв'язку з цим, ми надаємо докладний і доступний опис препаратів на сайті, а також рекомендації щодо застосування, підкреслюємо взаємодію з іншими речовинами і акцентуємо увагу на особливостях застосування у різних вікових груп і в залежності від наявних захворювань. Ми надаємо інструкції зрозумілою мовою.
                    </p>`,
        involvement: `<p>
                            <strong>
                                Залученість
                            </strong>
                        </p>

                        <p>
                            Для нас не буває поверхневих проблем, а, відповідно, не буває і поверхневих рішень. Кожну проблему, що виникає в компанії, ми вирішуємо з повною залученістю, занурюючись в її першопричини і залучаючи всіх учасників команди.
                        </p>

                        <p>
                           Такий підхід ми використовуємо і в рішенні ваших проблем. Коли дзвінок з повідомленням про проблему надходить оператору контакт-центру, інформація обов'язково передається менеджерам і залучаються всі члени команди, які не ляжуть спати, поки не вирішать проблемне питання. Після цього ми завжди особисто телефонуємо клієнту, щоб принести свої вибачення від всієї команди і повідомити, що питання вирішене.
                        </p>`,
        qualityAssurance: `<p>
                            <strong>
                                Гарантії якості
                            </strong>
                        </p>

                        <p>
                           Як електронна медична інформаційна система ми бачимо своїм завданням організацію вибору та доставки якісної продукції аптечного асортименту клієнту. Тому ми співпрацюємо з надійними аптеками-партнерами, яким товари медичного призначення постачають лише великі та перевірені дистриб'ютори в Україні.
                        </p>

                        <p>
                           Своєю чергою аптеки-партнери здійснюють перевірку всіх товарів, що надходять, через систему трирівневого контролю:
                            </p>

                            <ul>
                                <li>
                                    кожен етап реалізації лікарських засобів супроводжується чітким контролем температурного режиму та вологості (перша перевірка відбувається при надходженні продукції на склад, друга – при виході зі складу в аптеку, третя – при прийомі товару в аптеці);
                                </li>

                                <li>
                                    в аптеках відбувається відстеження продукції з терміном придатності, що закінчується, товар з таким терміном вилучається заздалегідь з реалізації;
                                </li>

                                <li>
                                    при надходженні продукції в аптеки-партнери уповноважена особа проводить вхідний контроль, перевіряє лікарські засоби на відсутність у&nbsp;
                                    <a target="_blank" href="http://pub-mex.dls.gov.ua/QLA/DocList.aspx">Реєстрі документів якості лікарських засобів</a>
                                    &nbsp;, обіг яких заборонено в Україні, а також проводить візуальний контроль за такими показниками як «Маркування», «Упаковка», «Термін придатності».
                                </li>
                            </ul>

                        <p>
                           До того ж, у кожному аптечному закладі, з яким ми співпрацюємо, покупець може попросити надати сертифікати якості на продукцію та інформацію про виробника чи дистриб'ютора — і ці документи будуть надані.
                        </p>`,
        policiesAndRules: `<h3>Політики і правила</h3>

                        <p>
                            Ми чітко регламентуємо свою діяльність, спираючись на ряд внутрішніх документів, які регулюють все, що відбувається у нашій компанії. І ми надаємо ці документи вам відповідно до нашого принципу прозорості.
                        </p>`,
        editorialPolicy: `<p>
                            <strong>
                                <a target="_blank" href="${links.editorialPolicy}">Редакційна політика</a>
                            </strong>
                            &nbsp;регулює процес створення контенту від а до я, направляє нашу діяльність відповідно до принципів і позначає суворі критерії якості для кожного типу контенту на сайті.
                        </p>`,
        marketingPolicy: `<p>
                            <strong>
                                <a target="_blank" href="${links.marketingPolicy}">Маркетингова політика</a>
                            </strong>
                            &nbsp;заявляє про наші відносини з рекламодавцями, а також позначає нашу позицію щодо реклами і спонсорського контенту.
                        </p>`,
        reviewPolicy: `<p>
                            <strong>
                                <a target="_blank" href="${links.reviewsPostingPolicy}">Політика публікації відгуків</a>
                            </strong>
                            &nbsp;покликана регулювати відносини між користувачами apteka24.ua та їх слововираженням на сайті, акцентуючи увагу на цензурі, взаємоповазі та правдивості наданої інформації з особистого досвіду.
                        </p>`,
        privacyPolicy: `<p>
                            <strong>
                                <a target="_blank" href="${links.privacyPolicy}">Політика конфіденційності</a>
                            </strong>
                            &nbsp;попереджає про збір персональних даних та можливості їх використання з боку apteka24.ua.
                        </p>`,
        userAgreement: `<p>
                            <strong>
                                <a target="_blank" href="${links.userAgreement}">Угода про використання</a>
                            </strong>
                            &nbsp;встановлює правила і умови використання сайту користувачами, які після реєстрації або без такої, користуються сайтом, його службами і послугами, що надаються apteka24.ua.
                        </p>`,
        returnConditions: `<p>
                            <strong>
                                <a target="_blank" href="${links.orderReturn}">Умови повернення</a>
                            </strong>&nbsp;&mdash;
                            документ, у якому зазначені згідно із законами України товари медичного призначення належної якості, що не підлягають обміну та поверненню, а також певні умови та процедуру, за яких товари неналежної якості можна обміняти або повернути.
                        </p>`,
        warranty: `<p>
                            <strong>
                                <a target="_blank" href="${links.warranty}">Гарантії якості</a>
                            </strong>&nbsp;&mdash;
                            це наш скрупульозний звіт про те, як, за яких умов і з дотриманням яких правил зберігається та транспортується продукція аптечного асортименту через наші аптеки-партнери.
                        </p>`,
        targetAudience: `<h3>Цільова аудиторія</h3>

                        <p>
                            Наша цільова аудиторія — це все населення України. Ми дотримуємося інклюзивного підходу і допомагаємо всім людям без винятку, незалежно від їх статі, віку, статусу, місця проживання і фізіологічних особливостей.
                        </p>`,
        wideAssortment: `<h3>Широкий асортимент</h3>

                        <p>
                            Електронна медична інформаційна система apteka24.ua пропонує один із найширших асортиментів засобів аптечного асортименту та медичних товарів в Україні. Каталог товарів, які можна знайти в аптеках-партнерах, містить понад 15 000 найменувань, серед яких є навіть рідкісні та ексклюзивні препарати.
                        </p>`,
        license: ``,
        contacts: `<h3>Контактна інформація</h3>

                        <p>
                            Юридична особа:&nbsp;
                            <span>
                                ТОВ «МІС-Сервіс» apteka24.ua.
                            </span>
                        </p>

                        <p>
                            Головний офіс apteka24.ua розташовується за адресою:
                        </p>

                        <ul>
                            <li>
                                Україна, 49100, Дніпропетровська обл., місто Дніпро, пр.Героїв, будинок 11Л, кабінет 321.
                            </li>
                        </ul>

                        <p>
                            Гаряча лінія:
                        </p>

                        <p>
                            <a href="tel:0800302244">0800 30 22 44</a> або <a href="tel:+380672042244">067 204 22 44</a>

                            <br />
                            <sub>(Безкоштовно з мобільного в межах України)</sub>
                        </p>

                        <p>
                            Звернутися до нас ви можете за адресою електронної пошти:&nbsp;

                            <a href="mailto:client@apteka24.ua">client@apteka24.ua</a>
                        </p>`,
        readMoreInfo: `<header class="about-section__header">
                    <h2>Дізнайтеся більше про нас</h2>
                </header>

                <div class="about-section__body">
                    <p>
                        Ми вважаємо, що усвідомлене ставлення до здоров'я виникає з освіченості, розуміння фізіологічних і психічних процесів, чому сприяє отримання достовірної і науково доведеної інформації в сфері медицини, охорони здоров'я і людського благополуччя.
                    </p>

                    <p>
                        Ми дотримуємося цього бачення в своїй роботі, ведемо просвітницьку діяльність з питань здоров'я, даємо людям можливість отримати необхідну допомогу і намагаємося вберегти наших користувачів від самолікування, нагадуючи, що тільки кваліфікований лікар може поставити правильний діагноз і призначити правильне лікування.
                    </p>

                    <p>
                        У той же час, ми усвідомлюємо, що людей, котрі вдаються до самолікування, досить багато. Тому ми публікуємо велику кількість інформаційного медичного контенту з питань здоров'я та застосування лікарських засобів для таких відвідувачів, щоб допомогти їм краще розібратися в питаннях здоров'я, попередити про симптоми передозування, побічні ефекти, особливості застосування, вікові обмеження, вплив кожного препарату на тканини, органи і системи органів, попереджаємо про взаємодію лікарських засобів і небезпеки застосування комбінацій препаратів без консультації лікаря.
                    </p>

                    <div class="about-subsection">
                        <h3>Наша мета і методи досягнення</h3>

                        <p>
                            Нашу основну мету ми бачимо в тому, щоб стати найнадійнішим джерелом інформації про ліки, медицину, здоров'я та досягнення добробуту, а також у спрощенні пошуку та замовлення товарів аптечного асортименту клієнтами.
                        </p>

                        <p>
                            Методи досягнення мети — укладання співпраці з аптеками-партнерами для надання інформації та можливості для пошуку та замовлення товарів аптечного асортименту клієнтам, а також надання незалежного, об'єктивного, повного та актуального медичного інформування у чіткому та лаконічному викладі, яке доступне та зрозуміле не лише працівникам сфери охорони здоров'я, а й звичайним людям.
                        </p>
                    </div>

                    <div class="about-subsection">
                        <h3>Наші завдання</h3>

                        <p>
                            У своїй діяльності ми виділяємо три основні завдання:
                        </p>

                        <ul>
                            <li>
                                просвітницька робота з питань здоров'я, медицини і благополуччя, що ведеться в освітньому форматі;
                            </li>

                            <li>
                                реалізація нашої позиції сполучної ланки між пацієнтом і лікарем, котру ми втілюємо в життя шляхом залучення людей до звернення до медичного фахівця;
                            </li>

                            <li>
                                надання можливості ознайомитися з інструкціями, описами і характеристиками препаратів, а також придбати призначені лікарем лікарські засоби та товари медичного призначення зручним способом за допомогою онлайн-замовлення в інтернет-аптеці.
                            </li>
                        </ul>
                    </div>

                    <div class="about-subsection">
                        <h3>Етика нашої компанії</h3>

                        <strong>
                            Наш головний етичний принцип — приносити користь людям.
                        </strong>

                        <p>
                            Тому ми надаємо тільки достовірну, актуальну і науково обґрунтовану інформацію, перевірену як редакційною командою, так і&nbsp;
                            <a target="_blank" href="/team/medical-experts/">командою медичних експертів</a>. Ми не розголошуємо дезінформацію, тому ретельно перевіряємо першоджерела і наукові дослідження. Для нас вкрай важливо, щоб всі матеріали на сайті були корисними для користувачів. Інформацію ми подаємо доступно і зрозуміло.
                        </p>

                        <p>
                            Допомагаючи здійснити замовлення та оформити доставку лікарських засобів та товарів медичного призначення, ми <a target="_blank" href="https://www.apteka24.ua/uk/about/warranty/">гарантуємо якість</a> продукції, що реалізується через наші партнерські аптеки, наявність сертифікатів та ліцензій у товарів аптечного асортименту, відповідність умовам зберігання та транспортування, починаючи зі складу до продажу товарів кінцевому споживачеві.
                        </p>

                        <p>
                            Через "МІС apteka24.ua" ви можете забронювати рецептурні препарати, проте купити їх ви можете тільки в аптеці-партнері та лише після пред'явлення рецепту, виписаного лікарем. Термолабільні препарати з аптек-партнерів відпускаються лише у відповідному термоконтейнері з холодоелементами.
                        </p>

                        <p>
                            Кожен аспект нашої діяльності відповідає законам України:
                        </p>

                        <ul>
                            <li>
                                <a target="_blank" href="https://zakon.rada.gov.ua/laws/show/123/96-%D0%B2%D1%80#Text">
                                    Закон України «Про лікарські засоби» від 04.04.96 №123;
                                </a>
                            </li>

                            <li>
                                <a target="_blank" href="https://zakon.rada.gov.ua/laws/show/220-2020-%D0%BF#Text">
                                    Постанова Кабінету Міністрів України від 23.03.2020 №220;
                                </a>
                            </li>

                            <li>
                                <a target="_blank" href="http://pravoved.in.ua/section-law/158-zuoapisp.html">
                                    Закон України «Про авторське право і суміжні права».
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div class="about-subsection">
                        <h3>База даних і джерела інформації</h3>

                        <p>
                            Для надання надійних і достовірних даних про лікарські препарати, товари медичного призначення, про здоров'я та медицину на сайті електронної медичної інформаційної системи apteka24.ua ми використовуємо офіційні джерела (державні, національні та міжнародні сайти, ресурси, бібліотеки, бази знань) і джерела з науково доказовою базою.
                        </p>

                        <p>
                            До офіційних джерел інформації відносяться:
                        </p>

                        <ul>
                            <li>
                                <a target="_blank" href="https://www.who.int/ru">
                                    Всесвітня організація охорони здоров'я;
                                </a>
                            </li>

                            <li>
                                <a target="_blank" href="https://moz.gov.ua/">
                                    Міністерство охорони здоров'я України;
                                </a>
                            </li>

                            <li>
                                <a target="_blank" href="https://zakon.rada.gov.ua/laws/show/2801-12#Text">
                                    Закон України «Основи законодавства України про охорону здоров&apos;я»;
                                </a>
                            </li>

                            <li>
                                <a target="_blank" href="https://zakon.rada.gov.ua/laws/show/123/96-%D0%B2%D1%80#Text">
                                    Закон України «Про лікарські засоби»;
                                </a>
                            </li>

                            <li>
                                <a target="_blank" href="http://www.drlz.com.ua/">
                                    Державний реєстр лікарських засобів України;
                                </a>
                            </li>

                            <li>
                                <a target="_blank" href="https://www.nlm.nih.gov/">
                                    Національна бібліотека медицини США;
                                </a>
                            </li>

                            <li>
                                <a target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/">
                                    База даних Національного центру біотехнологічної інформації США;
                                </a>
                            </li>

                            <li>
                                <a target="_blank" href="https://www.cdc.gov/">
                                    Центр по контролю і профілактиці захворювань;
                                </a>
                            </li>

                            <li>
                                <a target="_blank" href="https://www.fda.gov/">
                                    Управління з санітарного нагляду за якістю харчових продуктів і медикаментів (FDA).
                                </a>
                            </li>
                        </ul>

                        <p>
                            Інструкції та описи лікарських засобів і товарів медичного призначення складаються на підставі даних офіційних інструкцій&nbsp;
                            <a target="_blank" href="http://www.drlz.com.ua/">Державного реєстру лікарських засобів України</a>,
                            національних і міжнародних довідників з лікарських засобів&nbsp;
                            <a target="_blank" href="https://www.drugs.com/">(Drugs.com)</a>, а також згідно з офіційними даними виробника.
                        </p>
                    </div>

                    <div class="about-subsection">
                        <h3>Інформаційна база знань (блог)</h3>

                        <p>
                            На шляху до мети, що полягає в просвітницькому інформуванні людей з питань здоров'я, ми створили інформаційну базу знань в форматі блогу, в якому редакція висвітлює медичні та соціально значимі теми, обізнаність в яких необхідна для благополуччя людини.
                        </p>

                        <p>
                            Матеріали блогу містять достовірну, точну, надійну і актуальну інформацію, джерелами якої виступають державні, національні та міжнародні медичні сайти, ресурси, енциклопедії, довідники та бази знань.
                        </p>

                        <p>
                            Кожна стаття ретельно досліджується, а джерела перевіряються на предмет актуальності, достовірності та об'єктивності.
                        </p>

                        <p>
                            <a target="_blank" href="/team/">Авторів редакції</a>, які пишуть статті, ми навчаємо передовим методам ведення дослідницької журналістської діяльності, пошуку лідерів думок і професійних експертів, а також регулярно надаємо їм зворотний зв'язок і безперервне навчання.
                        </p>

                        <p>
                            Кожна стаття блогу медичної тематики перевіряється групою професійних медиків, фармацевтів або редакторів для забезпечення точності, достовірності, актуальності та релевантності. Верифікацію статей проводить наша&nbsp;
                            <a target="_blank" href="/team/medical-experts/">команда медичних експертів</a>.
                            Учасники даної команди — це висококваліфіковані фахівці широкого спектру медичних галузей, у яких за плечима великий досвід клінічної практики, досліджень і захисту інтересів пацієнтів.
                        </p>
                    </div>

                    <div class="about-subsection">
                        <h3>Каталог товарів і медикаментів</h3>

                        <p>
                            Ми є електронною медичною інформаційною системою, яка надає можливість користувачам та медичним фахівцям замовляти та бронювати лікарські засоби та товари медичного призначення.
                        </p>

                        <p>
                            Для реалізації цієї мети ми пропонуємо каталог товарів та медикаментів, у якому представлено понад 15 000 товарів медичного призначення.
                        </p>

                        <p>
                            Кожен товар обов'язково містить актуальне фото, офіційну інструкцію із застосування, відповідну&nbsp;
                            <a target="_blank" href="http://www.drlz.com.ua/">
                                Державному реєстру лікарських засобів України
                            </a>,
                            а також докладну інформацію, опис та характеристики товару, що дозволяють користувачам та медичним працівникам дізнатися всі необхідні дані про лікарський засіб або товар медичного призначення.
                        </p>

                        <p>
                            Вся інформація в каталозі відповідає офіційним джерелам та оновлюється відповідно до можливих змін у&nbsp;
                            <a target="_blank" href="http://www.drlz.com.ua/">
                                Державному реєстру лікарських засобів України
                            </a>,
                            з періодичністю не рідше одного разу на рік.
                        </p>

                        <p>
                            Проте ми не закликаємо відвідувачів сайту використовувати надані інструкції як посібник із самолікування. Пам'ятайте, що призначати лікування, дозування та спосіб приймання препарату може лише ваш лікар.
                        </p>
                    </div>

                    <div class="about-subsection">
                        <h3>Реклама</h3>

                        <p>
                            В електронній медичній інформаційній системі apteka24.ua може розміщуватися реклама та спонсорований контент. Однак ми абсолютно впевнені у своїй редакційній автономії і ніколи не дозволяємо спонсорам впливати на створюваний нами контент та послуги.
                        </p>

                        <p>
                            У нас є особливі правила з реклами та спонсорства, яким ми слідуємо, щоб реклама ніколи не заважала редакційній чесності та надійності.
                        </p>

                        <p>
                            Вся реклама, розміщена в електронній медичній інформаційній системі apteka24.ua, відповідає принципу корисності та обґрунтованості. Ми самі вибираємо рекламу, не дозволяємо нам нав'язувати думку рекламодавця і ніколи не станемо рекламувати те, що може потенційно нашкодити, є невиправдано дорогим або не несе доказової користі. Ми чітко розрізняємо контент, що спонсорується і не спонсорований, і не допускаємо перетину одного з іншим.
                        </p>
                    </div>

                    <div class="about-subsection">
                        <h3>Джерела фінансування</h3>

                        <p>
                            Ми отримуємо фінансування від реклами та спонсорованого контенту, а також від здійснення замовлень та бронювання лікарських засобів та товарів медичного призначення у нашій електронній медичній інформаційній системі. У деяких інформаційних статтях блогу також можуть розміщуватись посилання на товари, розміщені на нашому сайті. При переході користувача за такими посиланнями та при замовленні такого препарату ми можемо отримувати прибуток.
                        </p>

                        <p>
                            Реальність така, що фінансування цими способами дозволяє нам покривати більшу кількість витрат на створення якісного контенту та надавати більш ефективний сервіс обслуговування клієнтів електронній медичній інформаційній системі apteka24.ua.
                        </p>
                    </div>

                    <div class="about-subsection">
                        <h3>Конфлікт інтересів</h3>

                        <p>
                            Вся інформація, що є описом лікарських препаратів, дієтичних добавок та товарів медичного призначення розміщена відповідно до офіційних інструкцій з&nbsp;
                            <a target="_blank" href="http://www.drlz.com.ua/">
                                Державного реєстру лікарських засобів України
                            </a>,
                            а також виходячи з перевірених джерел медичної інформації.
                        </p>

                        <p>
                            Статті блогу представлені відповідно до офіційних даних вітчизняних та зарубіжних інформаційних джерел, які вказуються у тексті. Статті медичної тематики, що містять узагальнену інформацію про захворювання, стани, лікування, підготовлені редакцією електронної медичної інформаційної системи apteka24.ua.
                        </p>

                        <p>
                            Всі матеріали на сайті розміщуються відповідно до високих етичних принципів МІС apteka24.ua і не схильні до впливу спонсорів або інших третіх осіб.
                        </p>

                        <p>
                            Проте конфлікт інтересів може полягати в тому, що деякі фахівці (фармацевти та лікарі), що входять до складу&nbsp;
                            <a target="_blank" href="/team/medical-experts/">команди медичних експертів</a>, є співробітниками МІС apteka24.ua і отримують грошову винагороду за свою роботу, що може позначатися на їхньому позиціонуванні та подачі інформації у контенті сайту.
                        </p>

                        <p>
                            apteka24.ua не несе відповідальності за особисту думку та позиціонування кожного спеціаліста, проте намагається мінімізувати свідомо неправдоподібну або не корисну інформацію для відвідувачів сайту, відмовляючись від публікацій подібних статей.
                        </p>

                        <p>
                            Контент, що публікується, повинен бути корисним для здоров'я та благополуччя читачів і не завдавати шкоди їх фізичному та ментальному здоров'ю.
                        </p>

                        <p>
                            Лікарі та інші фахівці з галузі здоров'я та благополуччя співпрацюють з електронною медичною інформаційною системою apteka24.ua на благодійних засадах та не отримують за свою діяльність фінансову винагороду, що не виключає, але значно знижує конфлікт інтересів.
                        </p>
                    </div>
                </div>`
    },
    partners: {
        title: "Наші партнери"
    },
    howto: {
        title: "Як зробити замовлення",
        headText: `Незважаючи на те, що зробити покупку на нашому сайті дуже просто, ми все ж розповімо вам, як це зробити, щоб у вас взагалі не залишилося ніяких питань ;)`,
        howProcessGoing: `Як відбувається процес`,
        findProduct: `Знаходите потрібний товар`,
        registerOrder: `Оформляєте замовлення`,
        choosePaymentMethod: `Обираєте спосіб оплати`,
        awaitingParcel: `Очікуєте посилку :)`,
        find: `№1 Як знайти товар?`,
        searchMethods: `Знайти будь-який товар можна декількома способами — вам тільки потрібно вибрати, який з них для вас комфортніший.`,
        searchMethod1: `<b>Спосіб №1:</b> вписати назву препарату або товару в пошук.`,
        searchMethod2: `<b>Спосіб №2:</b> перейти в каталог, помандрувати по джунглях лікарських засобів і вибрати те, що ви шукали.`,
        buy: `№2 Як зробити покупку?`,
        buyInstruction: `Вибираєте товар, переходите по ньому — і тут же побачите всю потрібну інформацію: інструкцію, опис, характеристики, варіанти доставки і, звичайно, дві кнопки «Купити» і «Купити в один клік».`,
        buttonsFeatures: `У чому особливість цих двох кнопок?`,
        oneClickBuyButton: `Якщо вам зовсім не хочеться замислюватися над оформленням замовлення, просто натисніть
                                    <strong> «Купити в один клік»</strong> , щоб залишити у спливаючому віконці свій номер телефону — вам подзвонить наш оператор, уточнить всі деталі і оформить замовлення замість вас. Зручно, чи не так? ;)`,
        buyButton: `А ось для тих, хто жадає все робити самостійно, є кнопка «Купити» — тут вже треба буде самому заповнити всі поля і ввести дані. Там їх не так багато, не лякайтеся! ;)`,
        modals: `У спливаючих вікнах можна вибрати <strong>місто, куди потрібно доставити товари</strong>, визначитися зі
                <strong> способом доставки</strong> (в аптеку самовивозом або кур'єрськими службами в відділення або за вказаною адресою) і зі <strong>способом оплати</strong> (готівкою або карткою).`,
        itLookLike: `Виглядає це все ось так:`,
        addCertificate: `Доречі, якщо ви поставите галочку в графі <strong>«Додати сертифікат до товарів»</strong>
                        (після вибору способу доставки), то ми надішлемо сертифікати якості, щоб ви могли переконатися в надійності ліків.`,
        pushOrderButton: `Наостанок натискаєте кнопку <strong>«Оформити замовлення»</strong>  — і все, на цьому ваша робота закінчена і починається наша.`,
        pay: `№3 Як оплатити?`,
        payDescription: `<p>
                            Грошима;-) Причому, як готівкою, так і безготівковими.
                        </p>

                        <p>
                            При бажанні можна оплатити замовлення готівкою (післяплатою) кур'єру, в відділенні служби доставки або безпосередньо в аптеці.
                        </p>

                        <p>
                            Якщо ви не любитель знімати гроші в банкоматі, то оплата карткою на нашому сайті для вас теж є.
                        </p>

                        <p>
                            Між іншим, при самовивозі з аптеки також можна розплатитися карткою.
                        </p>

                        <p>
                            <strong>Приємних покупок!</strong>
                        </p>`
    },
    delivery: {
        title: "Доставка та оплата",
        warning: {
            description: `<span class="f-weight-5">Увага</span>: адресна доставка не поширюється на рецептурні лікарські препарати, препарати із переліку наркотичних засобів; психотропні, сильнодіючі чи отруйні речовини, а також препарати, що потребують особливих умов зберігання та транспортування!`
        },
        deliveryTypes: {
            title: "Способи доставки",
            items: [
                {
                    title: "Кур'єр «apteka24.ua»",
                    subtitle: "Швидка доставка на сьогодні чи на завтра",
                    preview: links.images.mobileApp.delivery.courier,
                    advantages: [
                        `Тариф за доставку замовлень складає мінімум <span class="f-weight-5">70 грн</span>`,
                        `Оплата карткою на сайті або готівкою кур'єру`,
                        `Замовленя мінімум від 250 грн`
                    ]
                },
                {
                    title: "Доставка Новою поштою",
                    subtitle: "Відправка товарів Новою поштою",
                    preview: links.images.mobileApp.delivery.post,
                    advantages: [
                        `Доставка у відділення Нової пошти - <span class="f-weight-5">70 грн</span>`,
                        `Оплата Карткою на сайті`
                    ]
                },
                {
                    title: "Самовивіз із аптеки",
                    // subtitle: `Забрать товары можно бесплатно в одной <a href=${links.pharmacy} target="_blank">из 1000 наших аптек по всей Украине</a>`,
                    preview: links.images.mobileApp.delivery.pickup,
                    advantages: [
                        `За наявності товару на полиці в аптеці отримання можливе у день замовлення`,
                        `Ціни на сайті відрізняються від цін в аптеках — на сайті вони нижчі`,
                        `Оплата готівкою або карткою при отриманні`,
                        `Безкоштовна доставка замовлень`
                    ]
                }
            ]
        },
        paymentTypes: {
            title: "Способи оплати",
            items: [
                {
                    title: "Оплата готівкою при отриманні",
                    preview: links.icons.cash,
                    description: "Оплата готівкою при отриманні доступна для будь-яких способів доставки. Ви можете сплатити замовлення готівкою при отриманні в наших аптеках, при зустрічі з кур'єром."
                },
                {
                    title: "Оплата карткою на сайті",
                    preview: links.icons.credit,
                    description: "Оплата банківською карткою доступна для будь-яких способів доставки. Ви можете сплатити за замовлення при його оформленні або пізніше – після отримання від нас повідомлення з підтвердженням замовлення. Замовлення, що доставляються до аптеки, можна сплатити безпосередньо при отриманні. Ми не беремо додаткову комісію за оплату карткою."
                },
                {
                    title: "Повернення коштів",
                    preview: links.icons.doubleRefresh,
                    description: "Повернення коштів за скасоване замовлення може тривати до 3 банківських днів. Повернення за замовленнями, що доставляються через службу Нова Пошта, після оформлення яких минуло менше ніж 2 години, надходить на картку одразу після скасування замовлення."
                }
            ]
        }
    },
    mission: {
        title: "Наша місія",
        alertInfo: `Ми прагнемо надати клієнтам сервіс та знання, необхідні для більш ефективного управління своїм власним здоров'ям, а також забезпечити безпеку лікування, допомагаючи пацієнтам скоротити кількість помилок при прийомі ліків.`,
        wayTitle: `Чому наш шлях такий?`,
        wayBody: `<p>
                        Кількість лікарських помилок і помилок самолікування, на нашу думку, досягає критичної межі. Ще більше нас пригнічує те, що ніхто не намагається виправити цю ситуацію. Як не сумно це визнавати, але аптечний бізнес, як і будь-який інший бізнес, здебільшого орієнтований на отримання прибутку. Але для нас дуже важливо, щоб ми приносили користь, а наш ресурс допомагав людям не тільки знайти відповіді на всі їхні запитання про здоров'я, а й допомагав наблизитися до свідомості у всьому, що стосується здоров'я, самопочуття, медицини та застосування лікарських засобів.
                    </p>

                    <p>
                        Тому ми бачимо своєю місією допомогти людям досягти свідомості і освіченості в сфері медицини і здоров'я. Для реалізації цієї місії ми надаємо такий сервіс і такі знання, які дозволяють людям дізнатися більше про свій організм, про фізіологічні і психічні процеси, про взаємодію ліків, про їх побічні ефекти і причини, чому вони можуть бути ефективні, щоб кожна людина могла прийняти усвідомлене рішення щодо свого здоров'я.
                    </p>`,
        targetTitle: `Як ми досягаємо своєї мети?`,
        targetBody: `<p>
                        Конкретним способом вирішення цих завдань являється наш блог про здоров'я, в якому ми висвітлюємо в статтях найактуальніші питання, докладно, і, головне, доступно, розповідаємо про те, що відбувається з людським організмом, і, звичайно, даємо зрозуміти кожному читачеві, що наша інформація може принести спокій і розуміння, але, звичайно, не може замінити консультацію, тому що тільки лікар може поставити правильний діагноз
                    </p>

                    <p>
                        Ми скрупульозно підходимо до заповнення інструкцій і описів препаратів, подаємо інформацію дуже докладно і доступно для широких мас населення, щоб кожна людина могла зрозуміти складні медичні терміни і розібратися в питаннях медицини. Саме це допомагає нашим відвідувачам приймати усвідомлені рішення при лікуванні і купівлі ліків.
                    </p>

                    <p>
                        Реалізуючи свідомий підхід до медицини і здоров'ю, ми надаємо нашим клієнтам можливість купувати тільки ліцензовані препарати і товари медичного призначення, займаємося просвітницькою діяльністю, попереджаємо про побічні ефекти, про можливість передозування і взаємодію лікарських засобів, закликаємо не займатися самолікуванням і надаємо інформацію з питань здоров'я, яка обов'язково проходить перевірку не тільки нашою редакцією, а й командою медичних експертів, в яку входять висококваліфіковані лікарі з багаторічним практичним досвідом і які щиро відстоюють інтереси пацієнтів.
                    </p>`
    },
    editorialPolicy: {
        title: "Редакційна політика",
        content: `<div class="about-page__content">
                    <h4 class="content__title">
                        Зміст:
                    </h4>

                    <ol>
                        <li><a href="#spheres">Сфери регулювання редакційної політики</a></li>
                        <li><a href="#principles">Наші етичні принципи</a></li>
                        <li><a href="#creation">Редакційний процес створення контенту</a></li>
                        <li><a href="#products">Редакційна політика медичних товарів</a></li>
                        <li><a href="#blog">Редакційна політика статей блогу</a></li>
                        <li><a href="#questions">Спірні питання</a></li>
                        <li><a href="#interests">Конфлікт інтересів</a></li>
                        <li><a href="#contacts">Співпраця і зворотний зв'язок</a></li>
                        <li><a href="#responsibility">Відмова від відповідальності</a></li>
                    </ol>
                </div>

                <p>
                    Ми знаємо, що довіру потрібно заслужити, тому вважаємо за необхідне розповісти, як apteka24.ua створює точний, зрозумілий, актуальний і науково доведений контент.
                </p>

                <p>
                    Знайти інформацію про здоров'я і благополуччя в інтернеті дуже просто — вона є всюди. Але знайти достовірну, актуальну і корисну інформацію — складно і навіть утомливо. apteka24.ua все змінює. Ми робимо інформацію про здоров'я зрозумілою і доступною, щоб ви могли приймати оптимальні та медично обґрунтовані рішення щодо свого здоров'я і здоров'я своїх близьких.
                </p>

                <h2 id="spheres">Сфери регулювання редакційної політики</h2>

                <p>Існуюча редакційна політика apteka24.ua регулює такі сфери діяльності і комунікації веб-сайту <a target="_blank" href="${links.homePage}">apteka24.ua</a>&nbsp;(далі — Сайт) з клієнтами:</p>

                <ul>
                    <li>головна сторінка Сайту;</li>
                    <li>навігація всіх сторінок Сайту;</li>
                    <li>каталог товарів;</li>
                    <li>картки товарів (інструкція, характеристика, опис, підбір аналогів);</li>
                    <li>опис акцій, програм лояльності, купонів і знижок;</li>
                    <li>статті блогу, огляди, дайджести, новинні оголошення;</li>
                    <li>email-розсилка, спливаючі повідомлення, інформування в чаті.</li>
                </ul>

                <h2 id="principles">Наші етичні принципи</h2>

                <p>
                    Принципи apteka24.ua, якими ми керуємося у своїй роботі і які організовують і визначають всі сфери регулювання редакційної політики, такі::
                </p>

                <h4>№1 Достовірність</h4>

                <p>Ми ретельно стежимо за тим, щоб вся інформація на Сайті була актуальною і правдивою.&nbsp;
                    <a target="_blank" href="${links.medicalExperts}">
                        Редакторська команда медичних експертів
                    </a>, що включає фармацевтів компанії і лікарів-експертів відповідної спеціалізації і компетенції, являється цензорами Сайту, перевіряє всі інструкції і описи до препаратів, стежить за правильністю підбору фото до товарів і достовірністю статей в блозі.
                </p>

                <h4>№2 Актуальність</h4>

                <p>На сайті розміщена тільки актуальна інформація, яка редагується по мірі її надходження і змін в офіційних джерелах. Інструкції до лікарських засобів регулярно оновлюються залежно від нових змін, внесених в&nbsp;
                    <a target="_blank" href="${links.stateRegisterOfDrugs}">Державний реєстр лікарських засобів України</a>,
                    або на сайті виробника.
                </p>

                <h4>№3 Корисність</h4>

                <p>
                    Ми дбаємо про те, щоб вся інформація, розміщена на Сайті, була корисною користувачам, просвітлювала, відповідала на питання і вирішувала проблеми.
                </p>

                <h4>№4 Відповідальність</h4>

                <p>
                    apteka24.ua несе повну відповідальність за всі матеріали та інформацію, опубліковані на Сайті. Ми гарантуємо достовірність, релевантність, надійність і актуальність всіх матеріалів, розміщених на Сайті.
                </p>

                <h4>№5 Наукова обґрунтованість</h4>

                <p>
                    Ми не використовуємо неперевірені факти і дані, а спираємося в своїх матеріалах тільки на офіційні і перевірені джерела інформації. Кожен тип контенту проходить обов'язкову верифікацію з боку медичного експерта, що входить в редакторську команду apteka24.ua.
                </p>

                <h4>№6 Джерела інформації</h4>

                <p>До джерел інформації на сайті apteka24.ua відносяться:</p>

                <p>
                    1. <strong>Офіційне джерело </strong> — надійне першоджерело, що володіє доказовими, науково і клінічно підтвердженими, схваленими Всесвітньою організацією охорони здоров'я або Міністерством охорони здоров'я України даними.
                </p>

                <p>До офіційних джерел відносяться::</p>

                <ul>
                    <li>
                        <a target="_blank" href="${links.worldHealthOrganization}">
                            Всесвітня організація охорони здоров'я;
                        </a>
                    </li>
                    <li>
                        <a target="_blank" href="${links.ukraineMinistryHealth}">
                            Міністерство охорони здоров'я України;
                        </a>
                    </li>
                    <li>
                        <a target="_blank" href="${links.lowOfUkraineAboutHealthProtection}">
                            Закон України «Основи законодавства України про охорону здоров&apos;я»;
                        </a>
                    </li>
                    <li>
                        <a target="_blank" href="${links.lowOfUkraineAboutDrugs}">
                            Закон України «Про лікарські засоби»;
                        </a>
                    </li>
                    <li>
                        <a target="_blank" href="${links.stateRegisterOfDrugs}">
                            Державний реєстр лікарських засобів України;
                        </a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.nlm.nih.gov/">
                            Національна бібліотека медицини США;
                        </a>
                    </li>
                    <li>
                        <a target="_blank" href="https://pubmed.ncbi.nlm.nih.gov/">
                            База даних Національного центру біотехнологічної інформації США;
                        </a>
                    </li>

                    <li>
                        <a target="_blank" href="https://www.cdc.gov/">
                            Центр по контролю і профілактиці захворювань;;
                        </a>
                    </li>
                    <li>
                        <a target="_blank" href="https://www.fda.gov/">
                            Управління з санітарного нагляду за якістю харчових продуктів і медикаментів (FDA).
                        </a>
                    </li>
                </ul>

                <p>
                    2. <strong>Перевірение джерело</strong> — першоджерело (наукова стаття, дисертація, огляд наукового дослідження), що володіє переконливими, але не досить достовірними даними, тому потребує перевірки на достовірність медичним експертом. Проходить обов'язкову верифікаційну перевірку уповноваженим цензором з вищою медичною або фармацевтичною освітою на відповідність фактів дійсності і науковій доказовості.
                </p>
                <p>
                    Кожен вид контенту на Сайті супроводжується статусом «Офіційне джерело» або «Перевірене джерело».
.
                </p>
                <h4>№7 Грамотність і точність</h4>
                <p>
                    Над кожним текстом проводиться редакторська робота, яка має на меті, щоб всі матеріали на Сайті були опубліковані без помилок і неуточнених деталей. Ми стежимо за орфографічною, пунктуаційною, граматичною, синтаксичною, лінгвістичною і семантичною грамотністю і точною подачею інформації.
                </p>
                <h4>№8 Унікальність
</h4>
                <p>
                    Ми не займаємося плагіатом. Всі наші статті проходять перевірку на унікальність і допускаються до публікації лише в тому випадку, якщо унікальність матеріалу досягає 95% і вище згідно сервісу text.ru.
                </p>

                <h4>№9 Доступність</h4>
                <p>Вся інформація, розміщена на Сайті apteka24.ua, повинна бути доступною і зрозумілою для широких мас населення. Не допускається використання двозначних, неуточнених і розмитих слів, фраз і виразів, а також термінології вузької спеціалізації без роз'яснення і уточнення смислової і семантичної спрямованості.</p>
                <p>Кожен тип контенту зобов'язаний бути максимально повним і розкривати всі питання по темі.</p>

                <h4>№10 Законність</h4>
                <p>Весь контент сайту зобов'язаний відповідати <a target="_blank" href="${links.lowOfUkraineAboutCopyright}">Закону України «Про авторське право і суміжні права»</a> і не порушувати авторське право першоджерел. Плагіат заборонений.</p>
                <p>Вся інформація підлягає глибокій і ретельній переробці та внесенню змін. При дослівному використанні інформації з офіційного або перевіреного джерела вказується гіперпосилання на першоджерело.</p>
                <p>Використання інструкції, характеристик і описів препаратів, вилучених з <a target="_blank" href="${links.stateRegisterOfDrugs}">Державного реєстру лікарських засобів України</a>, обов'язково супроводжується вказівкою знака копірайту © і найменуванням джерела.</p>


                <h2 id="creation">Редакційний процес створення контенту</h2>
                <p>Ми говоримо просто і доступно про складні теми і уникаємо використання медичної та наукової термінології без розкриття значення термінів доступною для розуміння мовою. Тому, якщо ви шукаєте засноване на фактах керівництво по конкретному захворюванню, з питань здоров'я або загальному самопочуттю, то ми тут саме для вас.</p>

                <p>Весь наш контент створюється для того, щоб ви могли прийти до загального добробуту, котрий досягається завдяки гармонійному взаємозв'язку психічного і фізичного. Ми допомагаємо встановити цей зв'язок і змінити спосіб життя. У нашому розумінні, як і в <a target="_blank" href="${links.worldHealthOrganizationFaq}">розумінні ВООЗ</a>&nbsp;<span class="text-green">[Офіційне джерело]</span>, це називається «загальним здоров'ям людини». І щоб слідувати цим шляхом, ми відкрито і об'єктивно висвітлюємо широке коло тем і точок зору на всі сфери життя людини..</p>

                <h4>Наша місія</h4>

                <p>Наша мета — бути вашим найнадійнішим союзником у прагненні до досягнення здоров'я і благополуччя. Ми хочемо бути тими, кому ви можете довіряти і хто вас не підведе. Тому у всьому контенті ми надаємо докази своєї надійності..</p>

                <h4>Процес створення контенту</h4>

                <p>Редакція і медичні експерти apteka24.ua прагнуть створювати якісний, актуальний, корисний і достовірний контент, дотримуючись найвищих журналістських стандартів в галузі медицини і здоров'я. Ми прагнемо надати вичерпні, неупереджені, чесні і своєчасні рекомендації та практичні поради, новини та огляди, керівництва та інструкції.</p>

                <h4>Наша команда медичних експертів</h4>

                <p>Медичний контент apteka24.ua створюється на підставі фактів, наукових даних і офіційних або перевірених джерел, а також перевіряється кваліфікованими авторами, редакторами, лікарями, фармацевтами та іншими фахівцями-консультантами <a target="_blank" href="${links.medicalExperts}">команди</a>, які поділяють і підтримують погляди нашої редакції.</p>

                <p>Контент загального здоров'я і соціокультурної сфери життя створюється з не меншою педантичністю, ґрунтується на авторитетних думках і висновках експертів, однак може містити непідтверджені науковим шляхом дані, так як галузі науки не в повній мірі покривають всі сфери життя людини та її інтересів. У розважальних категоріях блогу ми можемо розглядати емпірично непідтверджені, але поширені і ті, що мають місце бути актуальними, теми для людей з різними точками зору.</p>
                <h4>Наш процес верифікації контенту</h4>

                <p>Відомості про лікарські препарати, товари медичного призначення, а також інформація з питань здоров'я і благополуччя в блозі apteka24.ua перевіряються групою професійних медиків, фармацевтів або редакторів для забезпечення точності, достовірності, актуальності та релевантності.</p>

                <p>На нашу команду медичних цензорів можна покластися — це фахівці широкого спектру медичних галузей, у яких за плечима великий досвід клінічної практики, досліджень і захисту інтересів пацієнтів.</p>

                <h4>Наші автори</h4>

                <p>apteka24.ua ретельно оцінює всіх потенційних авторів статей про здоров'я і благополуччя. Перш, ніж ми опублікуємо статтю, ми обов'язково повинні переконатися, що автори контенту є фахівцями в предметній області, що освітлюється в контенті, а також, що у них є відповідний життєвий досвід.</p>

                <p><a target="_blank" href="${links.team}">Авторів редакції</a> ми навчаємо передовим методам ведення дослідницької журналістської діяльності, пошуку лідерів думок і професійних експертів, а також регулярно надаємо їм зворотний зв'язок і безперервне навчанняе.</p>

                <h4>Наші посилання, джерела і цитати</h4>

                <p>У нас суворі правила вибору першоджерел, так як ми покладаємося на  дослідження, що рецензуються, академічні дослідницькі інститути, урядові установи і медичні асоціації. Список джерел, інформація в яких вважається офіційними неспростовними даними, прописаний в нашій <a target="_blank" href="${links.editorialPolicy}">редакційній політиці</a>.</p>

                <p>Кожна стаття ретельно досліджується, а джерела перевіряються на предмет актуальності, достовірності та об'єктивності.</p>

                <p>Першоджерела, включаючи дослідження, наукові посилання і статистичні дані, вказуються активними посиланнями в кожній статті..</p>

                <h4>Наші оновлення та актуалізація</h4>

                <p>Редакція apteka24.ua постійно стежить за змінами в медичній, науковій та соціокультурній сферах. З появою нової інформації ми оновлюємо статті.</p>

                <p>У нас є встановлений графік обслуговування статей, що має на увазі щорічне оновлення контенту, однак оновлення можуть бути проведені заздалегідь в таких випадках:</p>

                <ul>
                    <li>поява нової доведеної інформації, яка спростовує попереднє положення;</li>
                    <li>зміни в стандартах лікування і догляду за хворими;</li>
                    <li>нові клінічні рекомендації;</li>
                    <li>вихід на ринок або відгук лікарських засобів;;</li>
                    <li>зміна істотних практичних рекомендацій;</li>
                    <li>звернення читачів, що аргументують прохання про зміну неактуального або недостовірного контенту.</li>
                </ul>

                <p>Читач може звернутися до нас з попередженням про потенційну проблему з нашим контентом, наприклад, про неточну, застарілу, нечітку або суперечливу інформацію. В такому випадку, ми реагуємо негайно і вживаємо заходів.</p>
                <p>Редакція і команда медичних експертів вивчають отримані відгуки, визначають, які зміни необхідно внести в контент, і повторно публікують оновлену інформацію</p>


                <h4>Наш tone of voice</h4>

                <p>Ми говоримо зрозуміло і доступно, тепло і по-домашньому, але при цьому наш голос звучить сміливо і прогресивно.</p>

                <p>Основний акцент у своїй мові ми робимо на простоту, точність, емпатію та відкритість. Позитивність подачі інформації відіграє важливу роль, так як ми хочемо вселяти надію і дарувати радість, а не зациклювати читачів на негативі. Ми використовуємо позитивну мову, яка стимулює до активних дій для зміни свого способу життя на кращу сторону..</p>

                <p>На всіх рівнях комунікації з читачами і клієнтами ми дотримуємося свідомості і намагаємося доносити інформацію максимально доступно і зрозуміло для будь-якої людини.</p>
                <h4>Ми чекаємо на вашу думку</h4>

                <p>Ми сповнені рішучості надавати вам тільки найпозитивніші враження і корисну інформацію. Тому ми будемо раді отримати від вас зворотній зв'язок з відгуками, питаннями і зауваженнями, адже ваша думка допоможе нам досягти більшого.</p>




                <h2 id="products">Редакційна політика медичних товарів</h2>

                <p>
                    Картки товарів на Сайті містять офіційну інструкцію, характеристики товару, опис та аналоги. Вся інформація відповідає офіційним джерелам і перевіряється уповноваженим медичним цензором.
                </p>

                <h4>№1 Інструкція</h4>
                <p>
                    Інструкції лікарських засобів і препаратів можуть бути взяті тільки з офіційного джерела <a target="_blank" href="${links.stateRegisterOfDrugs}">Державного реєстру лікарських засобів України</a>. Описи товарів медичного призначення повинні відповідати офіційному джерелу, яким є сайт виробника..
                </p>
                <p>
                    Інструкція заповнюється виключно українською мовою і повинна містити такі пункти:
                </p>

                <ul>
                    <li>склад;;</li>
                    <li>лікарська форма;</li>
                    <li>основні фізико-хімічні властивості;</li>
                    <li>фармакотерапевтична група;</li>
                    <li>фармакологічні властивості;</li>
                    <li>показання;</li>
                    <li>протипоказання;</li>
                    <li>взаємодія з іншими лікарськими засобами та інші види взаємодій;;</li>
                    <li>особливості застосування;;</li>
                    <li>затність впливати на швидкість реакції при керуванні транспортом і складними механізмами;</li>
                    <li>спосіб застосування та дози;</li>
                    <li>передозування;</li>
                    <li>побічні реакції;</li>
                    <li>термін придатності;</li>
                    <li>умови зберігання;</li>
                    <li>упаковка;</li>
                    <li>категорія відпуску;;</li>
                    <li>виробник;</li>
                    <li>місцезнаходження виробника.</li>
                </ul>

                <h4>№2 Характеристики</h4>
                <p>
                    Характеристики товарів заповнюються відповідно до офіційного джерела (<a target="_blank" href="${links.stateRegisterOfDrugs}">Державний реєстр лікарських засобів України</a>), являються коротким відображенням основних характеристик препарату, перевіряються медичним цензором на відповідність дійсності і містять такі пункти:
                </p>

                <ul>
                    <li>АТС-Класифікація;</li>
                    <li>рецептурний відпуск;</li>
                    <li>термін придатності;</li>
                    <li>придатний до;</li>
                    <li>дозування;</li>
                    <li>упаковка;</li>
                    <li>склад;</li>
                    <li>показання;</li>
                    <li>противопоказання;</li>
                    <li>код Моріон;</li>
                    <li>фармакотерапевтична група;</li>
                    <li>діюча речовина;</li>
                    <li>українська назва.</li>
                </ul>

                <h4>№3 Опис</h4>
                <p>
                    Опис лікарського засобу або препарату грунтується на офіційній інструкції (<a target="_blank" href="${links.stateRegisterOfDrugs}">Державний реєстр лікарських засобів України</a>) або маркетинговому матеріалі з офіційного сайту виробника і є доступним для пацієнта інформуванням про важливі властивості, взаємодії, клінічні характеристики та особливості лікарського засобу. Проходить перевірку медичним цензором на відповідність дійсності
                </p>

                <h4>№4 Алгоритм підбору аналогів лікарського засобу</h4>
                <p>Картка товарів кожного препарату містить його аналоги. Підбір аналогів лікарського засобу на сайті apteka24.ua відбувається за алгоритмом, затвердженим <a target="_blank" href="https://www.whocc.no/">Центром ВООЗ згідно методології статистики лікарських засобів</a> і прийнятим Міністерством охорони здоров'я України:</p>

                <ol>
                    <li>Перший рівень: аналогічні лікарські засоби з тією самою діючою речовиною, дозуванням і формою випуску.</li>
                    <li>Другий рівень: аналогічні лікарські засоби з тією самою діючою речовиною, дозуванням, але з іншою формою випуску.</li>
                    <li>Третій рівень: аналогічні лікарські засоби з тією самою діючою речовиною, але з іншим дозуванням і іншою формою випуску.</li>
                    <li>Четвертий рівень: аналогічні лікарські засоби, підібрані відповідно до АТС-класифікації, які можуть містити іншу діючу речовину, інше дозування і іншу форму випуску, але надають схожий клінічний ефект і можуть застосовуватися для лікування того ж захворювання або мають вплив на ту ж систему органів або органів.</li>
                </ol>

                <p>Точність проходження алгоритму перевіряється медичним цензором.</p>

                <h4>№5 Основні фізико-хімічні властивості</h4>
                <p>Картка товару повинна містити опис фізико-хімічних властивостей препарату.</p>

                <p>Даний розділ відображає класифікацію лікарських засобів в залежності від температурного режиму зберігання із зазначенням діапазону допустимих температур, що не порушують фізико-хімічні властивості препарату, а також форму випуску, об'єм, кількість в упаковці і дані про виробника.</p>

                <p>Інформація відповідає Державному реєстру лікарських засобів України та офіційному сайту виробника, а також перевіряється уповноваженим медичним цензором на відповідність дійсності.</p>

                <h4>№6 Сертифікат</h4>
                <p>Картка товару лікарського засобу містить посилання на скачування сертифіката якості..</p>

                <p>Сертифікат якості є гарантом достовірності лікарського препарату і стверджує відповідність якісних характеристик лікарського засобу його властивостями, заявленим в інструкції. Сертифікат якості видається препарату тільки після експертизи <a target="_blank" href="${links.stateServiceOfDrugsControl}">Державної служби України з лікарських засобів та контролю за наркотиками</a> та присудження препарату сертифіката GMP. Сертифікат якості відповідає вимогам українського законодавства, затвердженого реєстраційного свідоцтва, специфікації МКК (методи контролю якості) і сертифікату відповідності виробництва лікарських засобів відповідно до вимог GMP, а також проходить перевірку медичним цензором apteka24.ua на відповідність дійсності.</p>

                <h4>№7 Верифікація</h4>

                <p>Кожен інформаційний блок в картках товарів проходить верифікацію на релевантність інформації, її достовірність і наукову доказовість. Верифікацію проводить уповноважений медичний цензор, що належить до <a target="_blank" href="${links.medicalExperts}">редакційної команди медичних експертів</a> apteka24.ua.</p>
                <p>Інструкції повинні відповідати офіційному джерелу, яким <a target="_blank" href="${links.stateRegisterOfDrugs}">Державний реєстр лікарських засобів України</a>, бути точними і достовірними офіційним даними.</p>
                <p>У кожній картці товару вказується медичний експерт-цензор, який перевірив і схвалив її, а також статус контенту «Перевірено», при наведенні курсору на який спливає підказка, яка розкриває суть статусу.</p>

                <p>
                    Підказка статусу «Перевірено» містить наступну інформацію:
                    <i>
                        «Перевірено. Вся зазначена інформація відповідає офіційному джерелу і достовірним даним, перевірена і схвалена уповноваженим цензором на відповідність дійсності. Для того, щоб ознайомитися з редакційною політикою apteka24.ua натисніть на «Перевірено.
                    </i>
                </p>

                <p>
                    Кожна інструкція містить знак копірайту © з зазначенням офіційного джерела (<a target="_blank" href="${links.stateRegisterOfDrugs}">Державний реєстр лікарських засобів України</a>) і значок підказки з повідомленням про верифікацію інструкції. Підказка містить наступний текст:
                </p>

                <p>
                    <i>
                        Дана інструкція відповідає дійсності і є достовірною. Офіційне джерело: <a target="_blank" href="${links.stateRegisterOfDrugs}">Державний реєстр лікарських засобів України</a>&nbsp;<span class="text-green">[Офіційне джерело]</span>. Публікація інструкції та опису здійснена на підставі <a target="_blank" href="${links.editorialPolicy}">редакційної політики</a> apteka24.ua, відповідає «<a target="_blank" href="${links.lowOfUkraineAboutDrugs}">Закону України «Про лікарські засоби</a>» <span class="text-green">[Офіційне джерело]</span> і «<a target="_blank" href="${links.lowOfUkraineAboutCopyright}">Закону України «Про авторське право і суміжні права»</a> <span class="text-green">[Офіційне джерело]</span>,а також перевірена уповноваженим цензором. Оновлення інструкції на сайті apteka24.ua здійснюється після її поновлення на сайті Державного реєстра лікарських засобів України, або на офіційному сайті виробника.
                    </i>
                </p>

                <h4>№8 Оновлення</h4>

                <p>
                    Не рідше, ніж раз на рік, кожен інформаційний блок карток товарів (інструкція, характеристика, опис) повинен підлягати перегляду на предмет відповідності оновленням в офіційному джерелі <a target="_blank" href="http://www.drlz.com.ua/">Державний реєстр лікарських засобів України</a>. При виявленні оновлень в офіційному джерелі, дані поновлення повинні бути внесені в картку товару на Сайті.
                </p>
                <p>
                    Кожне оновлення карток товару підлягає верифікації з боку уповноваженого медичного цензора.
                </p>
                <h4>№9 Джерела інформації</h4>
                <p>До джерел інформації карток товарів відносяться тільки офіційні джерела:</p>

                <ul>
                    <li>
                        <a target="_blank" href="${links.stateRegisterOfDrugs}">
                            Державний реєстр лікарських засобів України
                        </a>;
                    </li>
                    <li>сайт виробника товарів.</li>
                </ul>



                <h2 id="blog">Редакційна політика статей блогу</h2>

                <h4>№1  Спрямованість блогу</h4>
                <p>
                    Блог apteka24.ua є великим інформаційним ресурсом, що включає рубрики як науково-медичної спрямованості, так і розважального характеру:
                </p>
                <ul>
                    <li>Здоров'я</li>
                    <li>Lifestyle</li>
                    <li>Краса</li>
                    <li>Психологія</li>
                    <li>Розваги</li>
                    <li>Подорожі</li>
                    <li>Foodstyle</li>
                    <li>How-To</li>
                    <li>Актуальне в світі</li>
                    <li>Наші новини</li>
                </ul>

                <p>
                    Блог apteka24.ua призначений для інформування широких мас населення з питань здоров'я в глобальному сенсі і не має на меті продаж лікарських засобів і товарів медичного призначення, розміщених на Сайті. Згадка торгових найменувань не рекомендується до використання в статтях блогу. Якщо ж торгові найменування згадуються, то лише в ознайомлювальних цілях.
                </p>

                <h4>№2 Стиль</h4>

                <p>
                    У статтях блогу загальноосвітнього та інформаційного характеру необхідно дотримуватися <strong>публіцистичного стилю</strong>. Допускається використання гумористичних, розмовних і метафоричних оборотів там, де необхідно зробити акцент на емоційній складовій або переслідується мета спонукальної дії.
                </p>

                <p>
                    У статтях медичної тематики, при описі препаратів, захворювань і їх лікування використовується <strong>науковий (академічний) стиль</strong>.
                </p>

                <h4>№3 Структура статті</h4>
                <p>В статтю повинні входити такі <strong>структурні елементи:</strong></p>

                <ol>
                    <li>Заголовок Н1.</li>
                    <li>Короткий вступ, присвячений темі статті, що не містить незначущих і неінформативних фраз.
                    </li>
                    <li>Підзаголовки Н2, що розділяють статтю на тематично відокремлені блоки, логічно пов'язані між собою.
                    </li>
                    <li>При необхідності можуть використовуватися підзаголовки Н3.</li>
                    <li>Використання цифрових (складних) і маркованих (простих) списків там, де це можливо і необхідно.
                    </li>
                    <li>Впровадження в текст статті візуального контенту у вигляді тематично підібраних ілюстрацій і рівномірно розподілених по тексту.
                    </li>
                    <li>У нижній частині статті повідомляється про інші статті на схожу тематику із зазначенням посилань на дані матеріали.
                    </li>
                    <li>Висновок по темі статті, що резюмує весь обсяг представленого матеріалу.
                    </li>
                    <li>Заключна фраза: «apteka24.ua бажає вам здоров'я!» Може використовуватися в різних варіаціях в залежності від теми статті.
                    </li>
                </ol>

                <h4>№4 Правила складання списків</h4>
                <p>Стаття може містити два види списків.</p>

                <p>Нумерований (приклад):</p>
                <ol>
                    <li>Список.</li>
                    <li>Список.</li>
                    <li>Список.</li>
                </ol>

                <p>Маркований (приклад):</p>
                <ul>
                    <li>список;</li>
                    <li>список;</li>
                    <li>список.</li>
                </ul>

                <p><strong>Правила оформлення нумерованого списку:</strong></p>
                <ol>
                    <li>Нумерований список — це складний список. Він містить розширене речення або кілька речень.
                    </li>
                    <li>Перша буква в кожному новому пункті списку — прописна (велика).</li>
                    <li>В кінці кожного пункту ставиться крапка.</li>
                </ol>
                <p><strong>Правила оформлення маркованого списку:</strong></p>
                <ul>
                    <li>простий список;</li>
                    <li>пункти містять словосполучення або слово;</li>
                    <li>перша буква — рядкова (маленька);</li>
                    <li>в кінці ставиться крапка з комою (;)</li>
                </ul>

                <h4>№5 Слова, речення, абзаци</h4>

                <ol>
                    <li>Неприпустимо використання ненормативної лексики і брутальних слів і виразів.</li>
                    <li>Звернення до читача — на «ви» з малої літери.</li>
                    <li>Позиціонування автора в тексті статті — від першої особи, використовуючи займенник «ми».</li>
                    <li>Написання назви інтернет-аптеки допускається наступним чином: Apteka24.ua і apteka24.ua (в разі, якщо мова йде про відсилання на веб-сайт).
                    </li>
                    <li>Речення краще використовувати короткі і зрозумілі, без впровадження складних конструкцій.</li>
                    <li>Кожен абзац повинен бути не більше 700 символів. Невеликі абзаци більш читабельні.</li>
                </ol>

                <h4>№6 Параметри тексту</h4>
                <p>Кожен текст проходить перевірку через сервіс <a target="_blank" href="https://text.ru/">text.ru</a>.
                    Згідно з цим сервісу параметри тексту повинні бути наступними:
                </p>

                <ul>
                    <li>заспамленість — не більше 55%;</li>
                    <li>вода — не більше 16-17%;</li>
                    <li>унікальність — від 95% і вище.</li>
                </ul>

                <p>Також статті проходять перевірку по сервісу «<a target="_blank" href="https://glvrd.ru/">Главред</a>»,
                    де повинна бути досягнута оцінка не менше 7 балів.
                </p>

                <h4>№7 Супровідний візуальний контент</h4>

                <p>Автор статті підбирає ілюстрації під тему написаного матеріалу.</p>

                <p>Зображення можна брати з вільних стічних фотобанків або використовувати власні унікальні зображення.</p>

                <p>Список фотобанків:</p>

                <ul>
                    <li><a target="_blank" href="https://pixabay.com/ru/">Pixabay</a>;</li>
                    <li><a target="_blank" href="https://unsplash.com/">Unsplash</a>;</li>
                    <li><a target="_blank" href="https://www.pexels.com/ru-ru/">Pexels</a>;</li>
                    <li><a target="_blank" href="https://ru.freeimages.com/">Freeimages</a>.</li>
                </ul>

                <p>Ілюстрації для контенту в деяких випадках можуть створюватися безпосередньо під статтю штатним дизайнером компанії.
                </p>

                <p><strong>Неприпустимо використання зображень наступного характеру:</strong></p>

                <ul>
                    <li>еротика і порнографія;</li>
                    <li>сцени насильства;</li>
                    <li>предмети інтимного призначення;</li>
                    <li>оголені інтимні частини тіла (навіть у немовлят);</li>
                    <li>люди з безліччю татуювань;</li>
                    <li>шприци;</li>
                    <li>велика кількість таблеток;</li>
                    <li>наркотичні речовини.</li>
                </ul>

                <p>Перевірка на допустимість використання зображення здійснюється через&nbsp;
                    <a
                        target="_blank"
                        href="https://cloud.google.com/vision/?fbclid=IwAR0jMzojgLKY3w9s_O0L8BRS9n4hAKq_L5muJvNfkgz12AqazuL-a61fQRQ"
                    >
                        сервіс перевірки зображень
                    </a>. Допускається використовувати ілюстрації, у яких у вкладці «Safe Search» відзначено не більше 2-х пунктів по кожному перерахованому параметру.
                </p>

                <p>
                    З метою дотримання <a target="_blank" href="${links.lowOfUkraineAboutCopyright}">Закону України «Про авторське право і суміжні права»</a> забороняється використання на Сайті авторських зображень без укладення письмового авторського договору про передачу виключних або невиключних авторських прав.
                </p>

                <h4>№8 Використання посилань на сторонні ресурси</h4>

                <p>Редакція apteka24.ua в статтях блогу в обов'язковому порядку вказує посилання на сторонні інформаційні ресурси, які є офіційними або перевіреними джерелами, які підтверджують достовірність поданої в матеріалі інформації. Однак ми не несемо відповідальність за інформацію, подану на цих ресурсах, і не відповідаємо за її достовірність, точність, надійність і релевантність.</p>

                <p>Редакція може вибирати певні сайти в якості пріоритетних відповідей на ваші пошукові запити, а також може дозволити рекламодавцям відповідати на певні пошукові запити рекламою або спонсорованим контентом.</p>

                <p>При цьому важливо розуміти, що apteka24.ua не рекомендує і не підтримує контент на будь-яких сторонніх веб-сайтах. Ми не несемо відповідальність за зміст зазначених в наших матеріалах сторонніх веб-сайтів і сайтів, створених в рамках реклами товарів чи послуг, сторонніх сайтів, представлених в якості результатів пошуку, або зовнішніх рекламних оголошень. Ми не даємо жодних гарантій щодо їх змісту або точності. Якщо ви переходите або використовуєте сторонні веб-сайти, то робите це на свій страх і ризик, несете особисту відповідальність за використання стороннього веб-сайту і користуєтеся ними відповідно до умов використання даного сайту.</p>

                <p>apteka24.ua не підтримує будь-які товари, що рекламуються в контенті сторонніх веб-сайтів..</p>

                <p>Ви можете дізнатися докладніше про <a target="_blank" href="${links.marketingPolicy}">маркетингову політику apteka24.ua</a>.</p>

                <h4>№9 Перевірка тексту</h4>
                <p>Кожен автор статей несе відповідальність за написаний текст.</p>

                <p>
                    Після написання матеріал потрібно вичитати і перевірити на наявність граматичних, синтаксичних, орфографічних, семантичних і пунктуаційних помилок.
                </p>

                <p>Надалі стаття відправляється на перевірку головному редактору.</p>

                <p>
                    Після перевірки головного редактора статті на медичну тематику перевіряються на достовірність членами редакційної команди медичних експертів відповідної компетенції і спеціалізації..
                </p>

                <h4>№10 Верифікація тексту</h4>
                <p>
                    Кожна стаття блогу підлягає верифікації з боку уповноваженого медичного експерта, що входить в редакційну команду медичних експертів apteka24.ua.
                </p>
                <p>
                    Статті блогу повинні бути достовірними, надійними та містити тільки доказові дані і супроводжуватися посиланнями на першоджерела (офіційні і перевірені джерела)..
                </p>

                <p>У кожній статті вказується автор статті і медичний експерт-цензор.</p>

                <p>
                    Кожна стаття супроводжується статусом «Перевірено» і значком зі спливаючою підказкою про верифікацію, що містить наступне повідомлення:
                </p>

                <p>
                    <i>
                        Дана інформаційна стаття відповідає дійсності, є достовірною і спирається на офіційні джерела. Публікація статті здійснена на підставі редакційної політики apteka24.ua, відповідає Закону України «<a target="_blank" href="${links.lowOfUkraineAboutDrugs}">Про лікарські засоби</a>» <span class="text-green">[Офіційне джерело]</span> і <a target="_blank" href="${links.lowOfUkraineAboutCopyright}">Закону України «Про авторське право і суміжні права»</a> <span class="text-green">[Офіційне джерело]</span>, а також перевірена уповноваженим цензором. Оновлення матеріалів на сайті apteka24.ua здійснюється по мірі виникнення нових відкриттів в області медицини і науки.
                    </i>
                </p>

                <h4>№11 Гарантії</h4>
                <p>
                    apteka24.ua гарантує унікальність опублікованого контенту, його актуальність, корисність і інформаційну наповненість.
                </p>

                <p>Кожна стаття, інструкція і опис товарів проходить три етапи перевірки:</p>

                <ol>
                    <li>Перевірка автором.</li>
                    <li>Перевірка головним редактором.</li>
                    <li>Перевірка медичним експертом відповідної спеціальності.</li>
                </ol>

                <p>Інструкції на сайті відповідають&nbsp;
                    <a target="_blank" href="${links.stateRegisterOfDrugs}">
                        Державному реєстру лікарських засобів України
                    </a>і редагуються в залежності від актуальних змін в реєстрі.
                </p>

                <p>
                    Кожна стаття повинна відповідати нормам моралі, суспільної корисності і не порушувати <a target="_blank" href="${links.lowOfUkraineAboutCopyright}">Закон України «Про авторське право і суміжні права»</a>.
                </p>



                <h2 id="questions">Спірні питання
</h2>

                <p>Будь-яка медична і наукова інформація, що подається в статтях блогу в рубриці «Здоров'я», не може містити непідтверджену інформацію, що суперечить офіційним науковим даним.</p>

                <p>У тому випадку, якщо на даний момент часу немає грунтовних і однозначно доказових даних, якщо тема суперечлива і думки медичних експертів і вчених розходяться по освітленому приводу, то необхідно в матеріалі вказати спірність даного питання. Така стаття повинна містити відмову від відповідальності з боку редакції з поясненням недостатньої доказовості питання.</p>

                <p>Блог apteka24.ua включає не тільки медичні теми, а й теми розважального характеру. У такому випадку інформація, що міститься в ненаукових статтях, носить лише ознайомлювальний характер, може не збігатися з думкою редакції і не має на меті образити читача з іншою точкою зору. Розважальна інформація не претендує на істинність і обґрунтованість і може бути лише одним з існуючих в світі думок та ідеологій.</p>


                <h2 id="interests">
                    Конфлікт інтересів
                </h2>

                <p>apteka24.ua співпрацює з медичними експертами — лікарями, психологами, фармацевтами та іншими представниками сфери здоров'я і благополуччя. Така співпраця в деяких аспектах може мати на увазі конфлікт інтересів.</p>

                <p>Конфлікт інтересів може полягати в тому, що деякі фахівці (фармацевти) є співробітниками apteka24.ua і отримують грошову винагороду за свою роботу, що може позначатися на їх позиціонуванні і подачі інформації в контенті сайту.</p>
                <p>apteka24.ua не несе відповідальність за особисту думку і позиціонування кожного фахівця, проте намагається мінімізувати свідомо неправдоподібну або не корисну інформацію для відвідувачів Сайту, відмовляючись від публікацій подібних статей..</p>

                <p>Опублікований контент повинен бути корисним для здоров'я і благополуччя читачів і не завдавати шкоди їх фізичному і ментальному здоров'ю.</p>

                <p>Лікарі та інші фахівці з області здоров'я і благополуччя співпрацюють з apteka24.ua на благодійних засадах і не отримують за свою діяльність фінансову винагороду, що не виключає, але значно знижує конфлікт інтересів.</p>

                <p>Якщо ви бачите на Сайті неправдоподібний, застарілий або помилковий контент, зверніться до редакції з повідомленням, і ми приймемо негайних заходів щодо усунення неточностей на Сайті.</p>



                <h2 id="contacts">Співпраця і зворотний зв'язок</h2>

                <p>
                    apteka24.ua пропонує співпрацю медичним експертам на правах реклами — фармацевтам та лікарям різних спеціалізацій. Експерти, які бажають співпрацювати, можуть стати частиною <a target="_blank" href="${links.medicalExperts}">редакторської команди медичних експертів apteka24.ua</a>.
                </p>

                <p>
                    Діяльність медичних експертів включає три напрямки:
                </p>

                <ul>
                    <li>вичитування, перевірка, внесення правок і схвалення текстів, написаних авторами редакції сайту;</li>
                    <li>написання власних авторських матеріалів з їх подальшою публікацією на блозі сайту;</li>
                    <li>інтерв'ювання з найбільш актуальних і важливих питань для читачів сайту.</li>
                </ul>

                <p>
                    Кожен вид діяльності при публікації супроводжується вказівкою медичного експерта в тілі статті з розміщенням його фотографії, ПІБ, спеціалізації, категорії, місця роботи і гіперпосилання на особистий профіль або профіль медичної клініки.
                </p>

                <p>
                    Для домовленості про співпрацю необхідно написати на пошту головного редактора apteka24.ua Юлії Щербаченко — <a href="mailto:editor@apteka24.ua">editor@apteka24.ua</a>.
                </p>

                <p>
                    Для отримання зворотного зв'язку за матеріалами Сайту необхідно звернутися за вищевказаною поштовою адресою.
                </p>



                <h2 id="responsibility">Відмова від відповідальності</h2>

                <p>У матеріалах, опублікованих на Сайті і що включають як інструкції, так і статті блогу, ми намагаємося відобразити найбільш достовірну інформацію, щоб максимально докладно і точно відповісти на питання відвідувачів. Ми робимо все можливе, щоб надавати науково доведені і надійні дані, проте ми не даємо жодних гарантій щодо нашого контенту і не несемо відповідальність за його подальше використання відвідувачами сайту.</p>

                <p>Пам'ятайте, що інформація, опублікована на Сайті, не є керівництвом до дії і носить суто ознайомчий характер. Самолікування може бути небезпечним для вашого здоров'я, і якщо ви наважуєтеся лікуватися без консультації лікаря, то це рішення на ваш страх і ризик.</p>

                <p>Інформація, яку ми надаємо на apteka24.ua, не призначена для заміни консультації з кваліфікованим медичним працівником — навіть найповніше інформування не є приводом для відміни відвідування лікаря. За всіма медичними питаннями для консультації, діагностування та призначення лікування необхідно звертатися до вашого лікаря.</p>

                <p>Наданий нами контент не призначений для використання в цілях діагностики або лікування. Повідомте свого лікаря про будь-які зміни в своєму самопочутті або про те, як ви збираєтеся змінити свій спосіб життя. Не нехтуйте медичними порадами і не відкладайте відвідування поліклініки через те, що ви прочитали на нашому сайті, в додатку або по інших каналах зв'язку корисну для вас інформацію.</p>

                <p>Якщо у вас виникнуть питання або побоювання з приводу будь-яких захворювань, будь ласка, зверніться до свого лікаря. Сайт apteka24.ua може ознайомити вас з питаннями здоров'я, захворювань і лікування, але він не замінить діагностику і консультацію фахівця.</p>

                <p>Редакція apteka24.ua не несе відповідальність за недоцільне використання інформації відвідувачами сайту.</p>`
    },
    marketingPolicy: {
        title: "Маркетингова політика",
        headerContent: `<p>
                        Якщо ви знаходитесь тут, значить, ви на крок ближче до здоров'я і благополуччя. А ми в електронній медичній інформаційній системі apteka24.ua робимо все можливе, щоб допомогти вам у цьому: підбираємо точні інструкції, пишемо інформативні статті і розміщуємо рекламні банери, акції, інформаційні бюлетені та підкасти тільки з корисною для вас інформацією.
                    </p>

                    <p>
                        Оскільки люди звертаються до нас з унікальними проблемами, з особистими історіями і запитаннями, ми дуже уважно до них прислухаємося і ставимо інтереси здоров'я та благополуччя людини на перше місце в нашій компанії.
                    </p>

                    <p>
                        Якраз з такого світогляду і ідеї виникає наш підхід до реклами на сайті електронної медичної  інформаційної системи apteka24.ua, який відповідає, підтримує і доповнює
                        <a href="${links.editorialPolicy}" target="_blank">
                            редакційну політику електронної медичної  інформаційної системи apteka24.ua.
                        </a>
                    </p>`,
        advertising: {
            title: `Рекламна політика`,
            description: `<p>
                    Електронна медична інформаційна система apteka24.ua отримує фінансування від реклами і спонсорського контенту. Реальність така, що фінансування від наших рекламодавців дозволяє нам покривати більшу кількість витрат на створення якісного контенту і надавати більш ефективний сервіс.
                </p>

                <p>
                    Будьте впевнені, ми абсолютно незалежні в своїй редакційній автономії. Ми ніколи не дозволяємо спонсорам впливати на створюваний нами контент і послуги, що надаються..
                </p>

                <p>
                    У нас є особливі правила по рекламі і спонсорству, яким ми слідуємо, щоб реклама ніколи не заважала редакційній чесності та надійності.
                </p>

                <p>
                    Вся реклама, яку ви бачите на сайті електронної медичної  інформаційної системи apteka24.ua, відповідає принципу корисності та обгрунтованості. Ми самі вибираємо рекламу, не дозволяємо нам нав'язувати точку зору рекламодавця і ніколи не станемо рекламувати те, що може потенційно нашкодити, є невиправдано дорогим або не несе доказової користі. Ми чітко розрізняємо спонсорований і не спонсорований контент і не допускаємо перетину одного з іншим.
                </p>

                <p>
                    У деяких випадках електронна медична інформаційна система apteka24.ua може створювати спільний або брендований контент у співпраці з нашими спонсорами та / або представляти контент, створений нашими спонсорами. Однак ми ніколи не суперечимо ідеї корисності і благополуччя.
                </p>

                <p>
                    У своїй рекламній політиці ми дотримуємося чітких правил:
                </p>`,
            items: `<div class="advertising__item">
                    <h4 class="item__title">
                        №1 Перевірка рекламних оголошень
                    </h4>

                    <p>
                        Ми на власний розсуд визначаємо типи реклами, які будуть відображені на ресурсах електронної медичної  інформаційної системи apteka24.ua. Ми залишаємо за собою право відхилити, скасувати або видалити будь-яку рекламу в будь-який час і з будь-якої причини, яку вважатимемо досить вагомою для подібної дії. Однією з причин для видалення реклами може стати скарга на оголошення, потенційний ризик можливої шкоди, відсутність явної користі.
                    </p>

                    <p>
                        Ми негайно повідомимо рекламодавця про відхилення, скасування або видалення будь-якого оголошення разом з поясненням. Ми також залишаємо за собою право визначати відповідне розміщення реклами на ресурсах електронної медичної  інформаційної системи apteka24.ua.
                    </p>
                </div>

                <div class="advertising__item">
                    <h4 class="item__title">
                        №2  Відмова від підтримки рекламованих товарів або послуг
                    </h4>

                    <p>
                        Ми не підтримуємо рекламовані на нашому ресурсі товари або послуги. Хоча деяка продукція може з'являтися на нашому сайті в форматі реклами, ні за яких обставин це не може розглядатися як схвалення рекламованих товарів, послуг або бренду, який виробляє, поширює або просуває ці товари і послуги.
                    </p>

                    <p>
                        У деяких випадках електронна медична інформаційна система apteka24.ua може оцінювати певні товари або послуги і складати з ними рейтинги. Ці рейтинги формуються виключно редакційною командою без урахування будь-яких фінансових або рекламних відносин, які можуть існувати з компаніями, що надають товари або послуги.
                    </p>
                </div>

                <div class="advertising__item">
                    <h4 class="item__title">
                        №3 Фільтрація рекламного контенту
                    </h4>

                    <p>
                        Ми ретельно відбираємо усю рекламу, що відображається на нашому ресурсі, і не приймаємо певні види реклами..
                    </p>

                    <p>
                        Ми не приймаємо рекламу, яка є неточною, суперечить здоровому глузду або ту, що може принести потенційну шкоду.
                    </p>

                    <p>
                        Фармацевтична реклама дозволена тільки для затверджених медикаментів і товарів медичного призначення, визначених <a href="${links.ukraineMinistryHealth}" target="_blank">Міністерством охорони здоров'я України </a>
                        і <a href="${links.stateRegisterOfDrugs}" target="_blank">Державним реєстром лікарських засобів України. </a>
                        При цьому рекламовані товари повинні бути присутніми на ринку і бути легко доступними.
                    </p>

                    <p>
                        Електронна медична інформаційна система apteka24.ua ні в якому разі не допускає розміщення реклами шкідливих, незаконних або небажаних товарів і послуг. Оголошення не повинні містити шахрайську інформацію, що вводить в оману, або образливі матеріали, включаючи матеріали, які спотворюють, висміюють або погрожують окремій людині або групі осіб, суперечачи принципу інклюзивності на підставі віку, кольору шкіри, національного походження, раси, релігії, статі, сексуальної орієнтації або інвалідності.
                    </p>

                    <p>
                        Оголошення не повинні бути пов'язані з алкоголем, порнографією, тютюном, імітацією новин або надзвичайної ситуації. Всі оголошення повинні чітко ідентифікувати рекламодавця. Будь-яке оголошення, яке подано двозначно і може бути невірно витлумачене як рекламне, буде чітко позначено як реклама.
                    </p>
                </div>

                <div class="advertising__item">
                    <h4 class="item__title">
                        №4 Розмежування реклами і редакційного контенту
                    </h4>

                    <p>
                        У кожному разі при розміщенні реклами ми проводимо чітку межу між рекламними оголошеннями і редакційними матеріалами. Вся реклама на електронній медичній інформаційній системі apteka24.ua чітко і недвозначно позначена як така плашкою «Промо» або «Акція». Натиснувши на оголошення або банер, користувач перейде на сторінку рекламодавця або спонсора, розташовану на сайті електронної медичної  інформаційної системи apteka24.ua.
                    </p>

                    <p>
                        Редакційний контент, спонсорований рекламодавцями, регулюється нашою
                        <a href="${links.editorialPolicy}" target="_blank"> редакційною політикою</a> і розглядається редакцією і <a href="${links.medicalExperts}" target="_blank">командою медичних експертів.</a>
                    </p>
                </div>

                <div class="advertising__item">
                    <h4 class="item__title">
                        №5 Посилання на товари в редакційному контенті
                    </h4>

                    <p>
                        При створенні редакційних матеріалів наші автори статей іноді використовують посилання на відповідні товари і медикаменти, розміщені на сайті для продажу, які, на їхню думку, можуть бути корисними для наших читачів.
                    </p>

                    <p>
                        Незважаючи на те, що всі медикаменти, товари і послуги, освітлені в статтях, вибираються незалежно і неупереджено <a href="${links.medicalExperts}" target="_blank">командою медичних експертів</a>,
                        ми хочемо, щоб ви знали, що електронна медична інформаційна система apteka24.ua отримує прибуток, якщо ви зробите покупку пропонованого товару після натискання на одне з посилань, які ми надаємо.
                    </p>
                </div>`
        },
        warning: `<strong>Зверніть увагу!</strong>

                        <br />
                        <br />

                        <p>
                            Інформація про медикаменти, товари і послуги надана виключно з ознайомчою метою і не повинна бути використана як керівництво до самолікування. Тільки лікар може прийняти рішення про призначення препарату, а також визначити дози і способи його застосування.
                        </p>

                        <p>
                            Електронна медична інформаційна система apteka24.ua не несе відповідальності за можливі негативні наслідки, що виникли в результаті використання інформації, розміщеної на сайті електронної медичної  інформаційної системи apteka24.ua.
                        </p>`
    },
    contacts: {
        title: "Контакти",
        clients: {
            toClients: "Клієнтам",
            description: "Безкоштовно в межах України",
            workTime: "з 8:00 до 20:00 (без вихідних)",
            pharmacyAddresses: "Адреси аптек"
        },
        correspondence: {
            address: "Адреса для кореспонденції",
            position: "49100, Дніпро, пр.Героїв, б. 11Л, каб. 321",
            time: "Пн-Пт з 9:00 – 18:00"
        },
        otherContacts: {
            items: [
                {
                    id: 1,
                    title: "Директор з маркетингу",
                    phone: "+38 (093) 122 85 39",
                    email: links.emails.marketing
                },
                {
                    id: 2,
                    title: "Постачальникам",
                    phone: "+38 (056) 795 91 78",
                    email: links.emails.supplier
                },
                {
                    id: 3,
                    title: "Оптовий продаж",
                    phone: "+38 (056) 731 94 68",
                    email: links.emails.wholesale
                },
                {
                    id: 4,
                    title: "Оренда приміщень",
                    phone: "+38 (095) 352 55 33",
                    email: links.emails.rent
                }
            ]
        }
    },
    publishingPolicy: {
        title: "Політика публікації коментарів і відгуків користувачів сайту apteka24.ua",
        description: `
                    <p>
                    Електронна медична інформаційна система apteka24.ua надає користувачам можливість публікувати свої коментарі та відгуки на сайті.
                </p>

                <p>
                    Мета цієї діяльності полягає в тому, щоб дати людям можливість поділитися власним досвідом і думками, а також задати питання загального або приватного характеру.
                </p>

                <p class="publishing-policy__alert-info alert-info">
                    Залишати відгуки та коментарі можуть тільки повнолітні користувачі, які досягли 18-річного віку.
                </p>

                <p>
                    Політика публікації коментарів і відгуків користувачів електронної медичної  інформаційної системи apteka24.ua застосовується до всіх коментарів і відгуків відвідувачів на сайті, в мобільному додатку і в соціальних мережах електронної медичної  інформаційної системи apteka24.ua (
                    <a href="${links.facebookA24}" target="_blank">
                        Facebook
                    </a>,&nbsp;

                    <a href="${links.instagramA24}" target="_blank">
                        Instagram
                    </a>,&nbsp;

                    <a href="${links.telegramA24}" target="_blank">
                        Telegram
                    </a>
                    ).
                </p>`,
        moderation: {
            title: `Модерація`,
            content: `<p>
                        Коментарі та відгуки на сайті електронної медичної  інформаційної системи apteka24.ua модеруються щодня.
                    </p>

                    <p>
                        До публікації допускаються тільки коментарі та відгуки, які пройшли модерацію &nbsp;
                        <a href="${links.team}" target="_blank">
                            редакційною командою електронної медичної  інформаційної системи apteka24.ua
                        </a>, яка включає перевірку на:
                    </p>

                    <ul>
                        <li>відповідність віку (18+);</li>
                        <li>овідсутність ненормативної лексики;</li>
                        <li>
                            відсутність неправдоподібної, потенційно небезпечної, загрозливої, образливої інформації, що суперечить принципу інклюзивності.
                        </li>
                    </ul>

                    <p>
                        Користувачі, що залишають коментарі і відгуки, не являються фахівцями в галузі охорони здоров'я. 
                        Якщо коментар або відгук залишає медичний працівник, то в даному випадку необхідно повідомити 
                        редакції електронної медичної  інформаційної системи apteka24.ua на пошту &nbsp;
                        <a href="mailto:editor@apteka24.ua">editor@apteka24.ua</a> або особистим повідомленням в 
                        соціальних мережах електронної медичної  інформаційної системи apteka24.ua про свій статус, підтвердивши його відповідними документами 
                        (диплом про освіту, сертифікат, посвідчення), після чого коментарю або відгуку буде присвоєно 
                        статус медичного працівника.
                    </p>

                    <p>
                        Модератори залишають за собою право редагувати надані матеріали та відгуки, які будуть визнані як недоречні або такі, що порушують ці правила, без повідомлення автора.
                    </p>`
        },
        commentsRules: {
            title: `Правила використання коментарів і відгуків`,
            content: `<p>
                        Вся інформація, представлена на електронній медичній інформаційній системі apteka24.ua, в тому числі та, що включає коментарі та відгуки користувачів сайту, призначена виключно для ознайомлення і жодним чином не є заміною прямих відносин між пацієнтом і лікарем. Пам'ятайте, що постановка діагнозу і вибір методики лікування здійснюється тільки вашим лікарем!
                    </p>

                    <p>
                        Елетронна медична інформаційна система apteka24.ua не несе відповідальності за можливі негативні 
                        наслідки, що виникли в результаті 
                        використання користувачами електронної медичної  інформаційної системи apteka24.ua інформації, 
                        розміщеної в розділі коментарів і відгуків
                    </p>

                    <p>
                        Читайте докладніше повну <a href="${links.responsibility}" target="_blank">Відмову від відповідальності</a>.
                    </p>`
        },
        confidential: {
            title: `Конфіденційність`,
            content: `<p>
                        Будь-яке повідомлення, опубліковане в розділі відгуків і коментарів може бути прочитано, використано, відтворено і процитовано всіма користувачами електронної медичної  інформаційної системи apteka24.ua..
                    </p>

                    <p>
                        Дізнайтеся більше про  <a href="${links.privacyPolicy}" target="_blank">Політику конфіденційності.</a>.
                    </p>`
        },
        speakRules: {
            title: `Правила спілкування`,
            content: `<p>
                        Всі учасники комунікації на сайті електронної медичної  інформаційної системи apteka24.ua (модератори і користувачі, що залишають коментарі) зобов'язуються дотримуватися правил хорошого тону, вести себе ввічливо і шанобливо, навіть якщо їх думки розходяться з думками інших людей.
                    </p>

                    <p>
                        Не допускається використання ненормативної лексики і надання принизливої чи образливої інформації, яка порушує принцип інклюзивності. Забороняється повідомляти свідомо невірну і неправдиву інформацію, здатну ввести інших користувачів в оману і завдати потенційної шкоди їх здоров'ю та добробуту.
                    </p>

                    <p class="publishing-policy__alert-info alert-info">
                        Використовуючи розділ коментарів і відгуків, ви погоджуєтеся публікувати правдиву і точну інформацію, засновану на вашому особистому досвіді.
                    </p>

                    <p>
                        Якщо інформація, яку ви публікуєте, не є особистим досвідом, ми просимо вас надати джерела (посилання, книги, журнали) цієї інформації, коли це доречно і можливо. Якщо ви заявляєте про статистику, наукові дані, дослідження і нові досягнення в медицині, то така інформація обов'язково повинна супроводжується підтвердженням з надійних і офіційних джерел згідно&nbsp;
                        <a href="${links.editorialPolicy}" target="_blank">редакційній політиці електронної медичної  інформаційної системи apteka24.ua</a>.
                    </p>

                    <p>
                        Користувачам сайту не дозволяється розміщувати рекламу в повідомленнях, наприклад, у вигляді текстових посилань або банерів.
                    </p>`
        }
    },
    team: {
        title: "Наша команда",
        aboutTeam: `
            <p>Команда електронної медичної інформаційної системи apteka24.ua - це люди, закохані в свою справу. Ми зібралися разом, щоб
                 переосмислити образ аптечних мереж, щоб викорінити недостовірність інформування в
                 медицині і щоб зробити здоров'я трендом, а не тим, про що намагаються не говорити.
            </p>
            <p>У нас працюють люди не просто з вищою освітою, але люди з масою талантів,
                 цілеспрямовані, організовані, відповідальні, бажаючі щодня приносити успіх
                 компанії. У нас різні спеціальності, але одне бачення. У нас є ідея. У нас є загальна
                 мета. І у нас є прагнення робити свою справу краще, ніж добре.
            </p>
            <p>А тепер давайте знайомитися особисто ;-)</p>    
            <h2>Керівництво</h2>     
        `,
        editor: `
            <h2>Редактори</h2>
            <p>Редакція електронної медичної інформаційної системи apteka24.ua народилася з людей, які точно знають, яким має бути текстовий сегмент сайту. В неї входять автори статей і контент-менеджери, які дотримуються редакційної політики сайту і створюють якісний і корисний контент.</p>
            <h3>Автори статей</h3>
            <p>Автори статей електронної медичної інформаційної системи apteka24.ua займаються наповненням блогу корисними і релевантними матеріалами, стежать за актуальністю і затребуваністю інформації, проводять інтерв'ю з експертами та лідерами думок, а також ведуть дослідницьку журналістську роботу з зарубіжними та вітчизняними джерелами.</p>
            <h3>Контент-менеджери</h3>
            <p>Контент-менеджери нашої команди — це фахівці в галузі контент-стратегії, які займаються наповненням товарів інструкціями, описами, характеристиками і підбором аналогів, а також стежать за оновленням і верифікацією інструкцій, що забезпечує актуальність важливої для пацієнта інформації.</p>
            
        `
    },
    privacyPolicy: {
        title: "Політика конфіденційності та захисту персональних даних на сайті apteka24.ua",
        content: `<h2>Загальні положення</h2>

                <p>Управління даним веб-сайтом <a href="/">www.apteka24.ua</a> (далі — «Сайт») здійснюється ТОВ «МІС-Cервіс», код ЄДРПОУ 43826536, юридичною особою, що зареєстрована та здійснює свою діяльність відповідно до вимог законодавства України (далі — «Компанія»)
                </p>

                <p>У цій політиці конфіденційності і захисту персональних даних (далі — Політика) пояснюється, яка Ваша інформація буде збиратися ТОВ «МІС-Cервіс» при доступі до веб-сайту&nbsp;
                    <a href="/">
                        www.apteka24.ua
                    </a>&nbsp;(далі «веб-сайт»), до всіх пов'язаних веб-сайтів (піддоменів), а також до інших послуг, що надаються ТОВ «МІС-Cервіс», на які посилається дана Політика. Відображається Політика, а також всі інші види зв'язку з Вами за допомогою письмових або усних засобів, таких як електронна пошта або телефон. У ній також описується, як інформація буде використовуватися, як ви можете контролювати збір, виправлення і / або видалення інформації і як зв'язатися з нами, якщо Вам потрібно.
                </p>

                <p>Справжня Політика поширюється на персональні дані, отримані як до, так і після її введення в дію.
                </p>

                <p>Наші методи забезпечення конфіденційності розроблені для забезпечення високого рівня захисту Ваших персональних даних. Ми не будемо використовувати або передавати Вашу інформацію будь-кому, крім випадків, описаних у цій Політиці конфіденційності. Справжня Політика визначена і регулюється Угодою використання, доступною на цьому сайті.
                </p>

                <p>Метою Політики є доведення до Вас необхідної інформації, яка дозволить оцінити, які персональні дані і з якими цілями обробляються нами, методи їх обробки і забезпечення безпеки.
                </p>

                <p>При використанні нашого сервісу Ви, повідомивши нам свої персональні дані, в тому числі за допомогою третіх осіб, визнаєте свою згоду на обробку своїх персональних даних відповідно до цієї Політики.
                </p>

                <p>У разі незгоди з умовами цієї Політики, Ви зобов'язані припинити використовувати наш сервіс.
                </p>

                <p>Нами не перевіряється достовірність персональних даних, наданих Вами, ми не маємо можливості оцінювати Вашу дієздатність. При цьому ми припускаємо, що Ви дієте сумлінно, обачно, надаєте достовірні та достатні персональні дані, а також докладаєте всіх необхідних зусиль у підтримці таких даних в актуальному стані і не порушуєте права третіх осіб.
                </p>

                <p>Погоджуючись з умовами цієї Політики, Ви підтверджуєте, що в момент збору персональних даних, Ви повідомлені про осіб, яким передаються персональні дані, зміст і цілі збору персональних даних. Ви підтверджуєте (гарантуєте), що персональні дані, які передали нам на обробку, передані за згодою власників персональних даних і в рамках Законодавства.
                </p>

                <p>Ви також погоджуєтеся з тим, що Власник персональних даних має право надавати доступ та передавати Ваші персональні дані третім особам без будь-яких додаткових повідомлень, виключно у тому випадку, якщо при цьому не змінюється мета їх обробки, і тільки у випадках, передбачених цією Політикою конфіденційності та / або законодавством України.
                </p>
                <p>Особи віком до 18 років не повинні надавати нам персональну інформацію через Онлайн-сервіс. Нами не збирається цілеспрямовано персональна інформація осіб молодше 18 років. Батьки та опікуни повинні постійно контролювати пов'язану з цим діяльність своїх дітей.
                </p>

                <p>Будь ласка, уважно прочитайте цю Політику конфіденційності, щоб зрозуміти наші погляди і практику щодо Ваших особистих даних, перш ніж переглядати цей веб-сайт.
                </p>

                <h2>1. Збір та використання персональних даних</h2>

                <p>Власником і розпорядником Ваших персональних даних є ТОВ «МІС-Cервіс».
                </p>

                <p>Компанія збирає тільки ті персональні дані (наприклад, Ваше ім'я і прізвище, логін і пароль доступу до особистого кабінету на сайті
                    &nbsp;
                    <a href="/">www.apteka24.ua</a>, адрес электронной почты, номер контактного телефона, дата рождения,
                    пол и т.д.), адресу електронної пошти, номер контактного телефону, дату народження, стать і т.д.), які свідомо і добровільно надані Вами як суб'єктом персональних даних в цілях використання сервісів Сайту, що відповідно до вимог законодавства є згодою суб'єкта персональних даних на обробку своїх персональних даних відповідно до сформульованої в цій Політиці метою їх обробки.
                </p>
;
                <p><strong>Склад персональних даних.</strong> Для здійснення своєї діяльності і для виконання своїх зобов'язань нами обробляються Ваші персональні дані, надані при реєстрації на сайті
                    &nbsp;
                    <a href="/">
                        www.apteka24.ua
                    </a>&nbsp; і зберігаються в особистому кабінеті.
                </p>

                <p>До персональних даних належать: прізвище, ім'я, по-батькові, адреса електронної пошти, номер мобільного / стаціонарного телефону, країна проживання, місце роботи, посада, дата народження.
                </p>

                <p>Ми просимо повідомляти тільки ті персональні дані, які необхідні для надання обраної Вами послуги, отримання інформаційної розсилки або відповіді на Ваш спеціальний запит. Якщо Ви повідомите нам додаткові персональні дані, ми також зможемо обробити їх з необхідним рівнем захисту..
                </p>

                <p>Дані, які автоматично нам передаються при використанні Вами нашого сервісу за допомогою встановленого на пристрої програмного забезпечення: IP-адреса, інформація про браузер і вид операційної системи пристрою, технічні характеристики обладнання і програмного забезпечення, дата і час доступу до онлайн-сервісу.
                </p>

                <ul>
                    <li>Ми запитуємо Ваші персональні та контактні дані тільки для здійснення Вашого замовлення і надання необхідної інформації про стан його виконання, реєстрації в особистому кабінеті клієнта, участі в рекламних активностях ТОВ «МІС-Cервіс» тощо
                    </li>

                    <li>Ваші персональні дані обробляються ТОВ «МІС-Cервіс» виключно в рамках Закону України «Про захист персональних даних». Такі дані, відповідно до вимог законодавства, що регулює правовідносини, пов'язані із захистом персональних даних, зберігаються, обробляються і використовуються в рамках всіх правовідносин, що виникають між Вами і ТОВ «МІС-Cервіс». Усі правовідносини, пов'язані з обробкою та захистом персональних даних, регулюються відповідним законодавством.
                    </li>

                    <li>Ваші персональні дані обробляються в наступних випадках:</li>

                    <li>при здійсненні (підтвердженні) Вами замовлення на сайті apteka24.ua, тобто при придбанні товарів і / або послуг, шляхом кліка в рядку «Оформити замовлення і відправити замовлення»;
                    </li>

                    <li>при реєстрації в особистому кабінеті клієнта на сайті apteka24.ua;</li>

                    <li>за участю в рекламних активностях ТОВ «МІС-Cервіс» відповідно до правил проведення таких заходів.
                    </li>

                    <li>Також ви повинні надати свою згоду на передачу (поширення) компанією ТОВ «МІС-Cервіс» ваших даних транспортно-експедиторським і кур'єрським організаціям, банкам або фінансовим установам і іншим третім особам, які забезпечують виконання Вашого замовлення на придбання товарів або виконання замовлених послуг.
                    </li>

                    <li>Такий перелік порядку надання згоди на обробку Ваших персональних даних не є вичерпним і узгоджується ТОВ «МІС-Cервіс» і клієнтом (споживачем) і / або доводиться до відома клієнта (споживача).
                    </li>

                    <li>ТОВ «МІС-Cервіс» гарантує, що персональні дані будуть зберігатися і оброблятися у відповідності до вимог Закону України «Про захист персональних даних»..
                    </li>

                    <li>ТОВ «МІС-Cервіс» використовує всі необхідні (cookies) куки, щоб забезпечити Вам надання максимально повної інформації про нас і наших можливостей, щоб Ви отримали якнайкращий досвід на нашому сайті. Якщо Ви продовжуєте користуватися нашим сайтом, це означає Вашу згоду на використання нами (cookies) і отримання Вами всіх файлів cookie, і нашу можливість відправляти Вам найсвіжішу інформацію про найактуальніші пропозиції та акції. Ви в будь-який час можете легко відмовитися від розсилки або заборонити використовувати куки шляхом персональних налаштувань Вашого девайса.
                    </li>

                    <li>При відвідуванні сайту apteka24.ua ми збираємо, зберігаємо і обробляємо таку інформацію як IP-адресу, дату і час відвідин, тип і мову браузера, файли cookies — виключно для надання послуг сайту і оптимізації його роботи, а також для захисту цілісності інформаційного простору сайту.
                    </li>

                    <li>Ця інформація є конфіденційною і не передається третім особам, крім обґрунтованих випадків, передбачених законами України, на прохання суб'єкта персональних даних або в інших випадках, викладених в даній Політиці.
                    </li>
                </ul>

                <h2>2. Цілі використання персональних даних</h2>

                <p>Ваші персональні дані використовуються з метою забезпечення надання сервісів сайту відповідно та для виконання законів України, в тому числі, але не виключно: «Про захист персональних даних», «Про інформацію», «Про рекламу», «Про телекомунікації», «Про захисту інформації в інформаційно-телекомунікаційних системах», Генерального регламенту про захист даних (ЄС) 2016/679 від 27.04.2016 р (EU General Data Protection Regulation, далі — GDPR) та іншого застосовного Європейського законодавства про захист даних, спільно іменоване далі — Законодавство, а також відповідно до Угоди про використання сайту та інших актів, що регулюють діяльність Компанії.
                </p>
                <p><strong>Метою обробки Ваших персональних даних є:</strong>
                </p>

                <ul>
                    <li>здійснення покладених на нас функцій відповідно до законодавства України і GDPR;</li>

                    <li>збір, зберігання і обробка персональних даних, отриманих в онлайн-сервісі в рамках Закону і GDPR;
                    </li>

                    <li>для відправлення Вам комерційних (маркетингових) повідомлень, що містять додаткову інформацію про послуги, актуальні акції та спеціальні пропозиції, що стосуються послуг, котрі надаються нами за допомогою нашого онлайн-сервісу;
                    </li>

                    <li>ідентифікація суб'єкта персональних даних при використанні онлайн-сервісу;</li>

                    <li>зв'язок з суб'єктом персональних даних у разі необхідності, в тому числі, напрямок пропозицій, інформаційних матеріалів, повідомлень, інформації та запитів, реклами, а також обробки запитів суб'єкта персональних даних;
                    </li>

                    <li>поліпшення якості онлайн-сервісу, зручності його використання, розробка нових функціональних можливостей і поліпшення якості обслуговування;
;
                    </li>

                    <li>проведення статистичних та інших досліджень на основі знеособлених даних.</li>

                </ul>

                <h2>3. Використання файлів Cookies</h2>

                <p>Cookie — це текстовий файл або файли, що містять невеликий обсяг інформації, які відправляються веб-браузеру і зберігаються на Вашому пристрої (комп'ютер, мобільний телефон або інший пристрій, за допомогою якого Ви відвідуєте Сайт)..
                </p>
                <p>Сookie-файли можуть бути постійними і зберігатися в комп'ютері, поки Ви їх не видалите, або тимчасовими / сесійними — вони зберігаються тільки до закриття браузера.
.
                </p>
                <p>Звертаємо увагу, що:
                </p>
                <ul>
                    <li>при повторному відвідуванні Вами сайту дані файлів cookie оновлюються;</li>

                    <li>в більшості випадків веб-браузер за замовчуванням допускає автоматичне збереження файлів cookie на своєму пристрої;
                    </li>

                    <li>відключення файлів cookie може призвести до обмеження доступу до опублікованих матеріалів і / або неповноцінного функціонування сервісів Сайту.
                    </li>
                </ul>

                <p>Ми робимо все для того, щоб зробити Ваше перебування на сайті максимально комфортним, для цього за допомогою файлів cookie нам необхідно аналізувати поведінку, вподобання і Ваші інтереси, що допоможе нам поліпшити досвід взаємодії з Сайтом, визначити найбільш зручний інтерфейс і навігацію сервісу..
                </p>

                <p>Відповідно до класифікації Міжнародної торгової палати (International Chamber of Commerce), нами використовуються такі категорії файлів cookie:
                </p>
                <p>Строго необхідні файли cookie, які потрібні для переміщення користувачем по веб-сторінці і при використанні певних сервісів (для доступу до захищених сторінок, реєстрації та авторизації, здійснення пошуку по сайту, запам'ятовування Ваших попередніх дій при переході на попередню сторінку в тій же сесії).
                </p>
                <p>Експлуатаційні файли cookie — агрегують інформацію про те, як використовується сайт. Такі дані зберігаються на Вашому пристрої між сеансами веб-браузера (час перебування на сайті, найбільш часто відвідувані сторінки, розуміння, які саме розділи і сервіси сайту були найбільш цікаві для Вас, ефективність тієї чи іншої рекламної та / або маркетингової кампанія і т.д .). Інформація, зібрана за допомогою експлуатаційних файлів cookie, призначена для статистичних та аналітичних задач.
.
                </p>
                <p>Функціональні файли cookie — використовуються для збереження параметрів та конфігурацій, які зберігаються на Вашому пристрої між сеансами веб-браузера (ім'я користувача, фото в профілі, інформація про залишені коментарі, мова сайту, місцезнаходження, відомості про те, чи надавалася Вам будь-яка інформація або обрані переваги раніше, а також інші параметри налаштування сайту). Такі файли cookie також дозволяють Вам дивитися відео, брати участь в інтерактивах (опитування, голосування) і взаємодіяти з соціальними мережами.
.
                </p>
                <p>Деякі дані файлів cookie можуть надаватися третім сторонам, які мають дозвіл з боку веб-ресурсу, і виключно для зазначених вище цілей.
                </p>
                <p>Цільові файли cookie — використовуються для надання контенту, який може Вас зацікавити. Ці дані зберігаються на Вашому пристрої між сеансами веб-браузера (відстеження рекомендованого текстового, графічного, аудіо- та відеоматеріалу, з метою уникнути повторного показу, управління цільової рекламою, оцінки ефективності рекламних кампаній, інформація про відвідування користувачем інших ресурсів при переходах). Сайт може ділитися цією інформацією з іншими сторонами, включаючи медіа-клієнтів, рекламодавців, агентств і партнерів по суміжному бізнесу для того, щоб вони надавали якісну таргетовану рекламу..
                </p>
                <p><strong>Cookie-файли сторонніх сервісів і сервісів аналітики:</strong>
                </p>
                <p>Для оперативної доставки, більш якісного відображення і детального аналізу контенту на Сайті, ми користуємося послугами, які є власністю інших сторонніх компаній, таких як Facebook, Twitter, Instagram, Alphabet Inc., Hotjar і інші. Наведені, як приклад, компанії можуть використовувати файли cookie на своєму пристрої, під час роботи на сайті. Слід звернути увагу, що сайт не може вплинути на роботу файлів cookie, які використовуються цими сервісами. Всі необхідні відомості про їх використання можна дізнатися, відвідавши відповідний ресурс.
                </p>
                <ul>
                    <li>Умови використання&nbsp;
                        <a
                            target="_blank"
                            href="http://www.google.com/analytics/terms/ru.html"
                        >Google Analytics
                        </a>
                    </li>

                    <li>Політика використання даних&nbsp;
                        <a
                            target="_blank"
                            href="https://www.facebook.com/about/privacy/"
                        >Facebook
                        </a>
                    </li>

                    <li>Політика використання&nbsp;
                        <a
                            target="_blank"
                            href="https://www.hotjar.com/legal/policies/privacy/"
                        >Hotjar
                        </a>
                    </li>

                    <li>Політика приватності <a target="_blank" href="https://www.admitad.com/ua/privacy/">Admitad</a>
                    </li>

                    <li>Політика конфіденційності&nbsp;
                        <a
                            target="_blank"
                            href="https://esputnik.com/politika-konfidencialnosti"
                        >eSputnik
                        </a>
                    </li>
                </ul>
                <p><strong>Управління файлами cookie:</strong>
                </p>

                <p>Основні веб-браузери (перераховані нижче) налаштовані на автоматичний прийом файлів cookie. Для того, щоб їх відключити, скористайтеся функцією довідки у своєму браузері. Довідку можна викликати через меню або за допомогою кнопки F1.
                </p>

                <ul>
                    <li>
                        <a
                            target="_blank"
                            href="https://privacy.microsoft.com/ru-ru/privacystatement"
                        >Microsoft Edge
                        </a>
                    </li>

                    <li>
                        <a
                            target="_blank"
                            href="https://www.mozilla.org/ru/privacy/websites/#cookies"
                        >Mozilla Firefox
                        </a>
                    </li>

                    <li><a target="_blank" href="https://support.google.com/chrome/answer/95647?hl=ru">Google Chrome</a>
                    </li>

                    <li><a target="_blank" href="http://help.opera.com/Windows/11.50/ru/cookies.html">Opera</a></li>

                    <li><a target="_blank" href="https://support.apple.com/uk-ua/guide/safari/sfri11471/mac">Safari for macOS</a>
                    </li>
                </ul>

                <p><strong>Звертаємо увагу:</strong>
                </p>

                <ul>
                    <li>конфігурація налаштувань файлів cookie для веб-браузерів мобільних пристроїв може відрізнятися;</li>

                    <li>слід нагадати, що повноцінна робота з сайтом доступна тільки при використанні файлів cookie;
                    </li>

                    <li>відключення файлів cookie може призвести до обмеження доступу до змісту і до неповноцінного функціонування сервісів сайту.
                    </li>
                </ul>

                <p>Щоб звернутися до нас з приводу використання файлів cookie, відправте повідомлення по електронній пошті на email&nbsp;
                    <a href="mailto:client@apteka24.ua">client@apteka24.ua</a>
                </p>
                <p>Якщо Ви не вмикаєте використання файлів cookie або навмисно видаляєте всі файли cookie зі свого веб-браузера, то при подальших відвідинах сайту Вам буде повторно запропоновано ввімкнення і використання файлів cookie.
                </p>
                <p>Інформація про Вас, отримана за допомогою файлів cookie, не продається і не поширюється у відкритому доступі, є власністю компанії, якій належить ресурс.
                </p>

                <h2>4. Посилання на інші сайти</h2>

                <p>Цей сайт містить посилання на інші сайти. Справжня Політика конфіденційності відноситься тільки до цього сайту, тому, коли Ви переходите за посиланням на інші сайти, Ви повинні прочитати їх власну політику конфіденційності. ТОВ «МІС-Cервіс» не несе відповідальності за політику конфіденційності або зміст таких веб-сайтів.
                </p>

                <h2>5. Умови безпеки зберігання персональних даних</h2>
                <p>Ми зберігаємо Ваші персональні дані до тих пір, поки це необхідно для виконання цілей, для яких вони були зібрані, як описано вище. Критерії, які ми використовуємо для визначення термінів зберігання персональних даних, включають наступне: зберігання відповідно до вимог законодавства та нормативних вимог. Ми можемо зберігати та використовувати Вашу інформацію для виконання наших юридичних зобов'язань, вирішення спорів, запобігання зловживань.
                </p>
                <p>Ми прагнемо використовувати відповідні технічні та фізичні заходи безпеки для захисту Ваших особистих даних, які ми передаємо, зберігаємо або обробляємо іншим чином від випадкового або незаконного знищення, втрати, зміни, несанкціонованого розкриття або доступу.
                </p>
                <p>При використанні Вами сервісів на сторінках Сайту можуть бути присутніми коди інших інтернет-ресурсів і третіх осіб, в результаті чого такі інтернет-ресурси і треті особи отримують Ваші дані. Отже, ці інтернет-ресурси можуть отримувати і обробляти інформацію про те, що Ви відвідали ці сторінки, а також іншу інформацію, яку передає браузер користувача. Такими Інтернет-ресурсами можуть бути:
                </p>
                <ul>
                    <li>системи банеропоказів (наприклад, DoubleClick for Publishers, Admixer, AdRiver та ін.)</li>

                    <li>соціальні плагіни мереж (наприклад, Discus, Facebook, Twitter, Google+)</li>
                </ul>
                <p>Використання зазначених сервісів нам необхідно для оперативного аналізу відвідувань сайту, внутрішньої і зовнішньої оцінки відвідуваності сайту, глибини перегляду, активності користувачів. Дані, отримані від зазначених сервісів, ми не зберігаємо і не обробляємо.
                </p>
                <p>Відповідно, якщо в силу будь-яких причин Ви не бажаєте, щоб зазначені послуги отримували доступ до Ваших персональних даних, Ви можете за власним бажанням вийти зі свого аккаунта або профілю, очистити файли cookie (через свій браузер).
                </p>

                <h2>6. Захист персональних даних</h2>

                <p>ТОВ «МІС-Cервіс» використовує загальноприйняті стандарти технологічного та операційного захисту інформації та персональних даних від втрати, неправильного використання, зміни або знищення. При цьому, незважаючи на всі зусилля, ми не може гарантувати абсолютну захищеність від будь-яких загроз, які виникають поза межами регулювання нашою компанією. Нами забезпечується використання усіх відповідних зобов'язань щодо дотримання конфіденційності, а також технічних і організаційних заходів безпеки для запобігання несанкціонованого або незаконного розголошення або обробки такої інформації і даних, їх випадкової втрати, знищення або пошкодження. Ми надаємо доступ до інформації і персональних даних тільки уповноваженим працівникам, які дали згоду на забезпечення конфіденційності такої інформації і даних відповідно до вимог ТОВ «МІС-Cервіс». Поширення персональних даних без згоди суб'єкта персональних даних або уповноваженої ним особи дозволяється у випадках, визначених законом, і лише (якщо це необхідно) в інтересах національної безпеки, економічного добробуту та прав людини.
                </p>

                <h2>7. Ваші права як суб'єкта персональних даних</h2>
                <p>Компанія доводить до Вашого відома інформацію про Ваші права як суб'єкта персональних даних, які врегульовані Законом України «Про захист персональних даних», а саме:
                </p>
                <ol>
                    <li>знати про джерела збору, місцезнаходження своїх персональних даних, мету їх обробки, місцезнаходження або місце проживання (перебування) власника чи розпорядника персональних даних або надати відповідне доручення щодо отримання цієї інформації уповноваженим ним особам, крім випадків, встановлених законом;
                    </li>

                    <li>отримувати інформацію про умови надання доступу до персональних даних, зокрема, інформацію про третіх осіб, яким передаються персональні дані;
                    </li>

                    <li>на доступ до своїх персональних даних;</li>

                    <li>отримувати не пізніше, ніж за тридцять календарних днів з дня надходження запиту, крім випадків, передбачених законом, відповідь про те, чи обробляються персональні дані, а також отримувати зміст таких персональних даних;
                    </li>

                    <li>пред'являти вмотивовану вимогу власнику персональних даних із запереченням проти обробки своїх персональних даних;
                    </li>

                    <li>пред'являти вмотивовану вимогу щодо зміни або знищення своїх персональних даних будь-яким власником і розпорядником персональних даних, якщо ці дані обробляються незаконно чи є недостовірними;
                    </li>

                    <li>на захист своїх персональних даних від незаконної обробки та випадкової втрати, знищення, пошкодження у зв'язку з умисним приховуванням, ненаданням чи несвоєчасним їх наданням, а також на захист від надання відомостей, що є недостовірними чи ганьблять честь, гідність та ділову репутацію фізичної особи;
                    </li>

                    <li>звертатися зі скаргами на обробку своїх персональних даних до Уповноваженого Верховної Ради України з прав людини або до суду;
                    </li>

                    <li>застосовувати засоби правового захисту у разі порушення законодавства про захист персональних даних;
                    </li>

                    <li>вносити застереження стосовно обмеження права на обробку своїх персональних даних під час надання згоди;
                    </li>

                    <li>відкликати згоду на обробку персональних даних;</li>

                    <li>знати механізм автоматичної обробки персональних даних;</li>

                    <li>на захист від автоматизованого рішення, яке має правові наслідки.</li>
                </ol>

                <p>Для поновлення, отримання доступу, внесення змін, блокування або видалення своїх персональних даних, відкликання згоди на обробку персональних даних, яке Вами надано нам згідно з цією Політикою, або в разі наявності будь-яких зауважень, побажань чи претензій щодо Ваших персональних даних, які нами обробляються, будь ласка, звертайтеся до нас: по електронній пошті&nbsp;
                    <a href="mailto:client@apteka24.ua">client@apteka24.ua</a> або напишіть листа на адресу: 49100, м Дніпро, пр.Героїв, д. 11Л, каб. 321.
                </p>

                <h2>Зміни в Політиці конфіденційності та захисту персональних даних</h2>
                <p>Ми залишаємо за собою право змінювати дану Політику конфіденційності в будь-який час на власний розсуд та без попереднього повідомлення. Якщо ми внесемо зміни в справжню Політику конфіденційності, вони будуть розміщені на веб-сайті, щоб Ви володіли актуальною інформацією. Нова редакція Політики вступає в силу з моменту її розміщення на сайті, якщо інший термін не передбачено новою редакцією Політики. Якщо після ознайомлення зі змінами Ви не відмовитеся від їх прийняття в письмовій формі, це буде означати, що Ви погоджуєтеся з відповідними змінами Політики. Пропонуємо періодично переглядати Політику для того, щоб бути проінформованими про зміни або доповнення.
                </p>`
    },
    massMedia: {
        title: "ЗМІ про нас"
    },
    agreement: {
        title: "Угода про використання apteka24.ua. Предмет згоди",
        content: `<p class="warning-text color-red">
                    Будь ласка, перед переглядом нашого сайту уважно прочитайте умови Угоди. Якщо Ви не згодні з умовами, не використовуйте наш сайт.
                </p>
                <p>
                    Ця угода регулює відносини між Власником Сайту, і Вами (далі — Користувач), що виникають у зв'язку з використанням Сайту.
                </p>
                <h2>Терміни Угоди</h2>
                <p>
                    Для цілей даної Угоди наступні слова і вирази мають такі значення:
                </p>
                <ul>
                    <li><strong>Власник</strong> - Товариство з обмеженою відповідальністю «МІС-Cервіс» (код ЄДРПОУ 43826536) знаходиться за адресою: 49100, м. Дніпро, пр.Героев, д. 11Л, каб. 321, що є однією зі сторін Угоди.
                    </li>
                    <li><strong>Користувач</strong> - це будь-яка особа, яка звертається, підключається або надає будь-якій сторонній особі допомогу в отриманні будь-якого роду інформації або інформаційного наповнення, які розміщені на Сайті Власника, а так само і пов'язані зі даним Сайтом посиланнями, завантаженими з Сайту, або отриманими шляхом звернення до Сайту, в тому числі та, що добровільно пройшла реєстрацію на Сайті і є однією зі сторін Угоди.
                    </li>
                    <li><strong>Угода</strong> - дана Угода, укладена Власником і Користувачем.</li>
                    <li><strong>Сторона і Сторони </strong> - означає відповідно Власника або Користувача окремо, або Власника і Користувача спільно.
                    </li>
                    <li><strong>Реєстрація</strong> - процедура, в ході якої Користувач надає дані про себе у затвердженній Власником формі. Реєстрація вважається завершеною тільки в разі успішного проходження Користувачем всіх її етапів, включаючи активацію, здійснювану шляхом натискання кнопки «Реєстрація», що є автоматичним підтвердженням добровільної реєстрації Користувача, без натискання відповідної кнопки Реєстрація не провадиться — обліковий запис не створюється. Користувач цим визнає, що дає згоду на автоматизовану, а також без використання засобів автоматизації, обробку його персональних даних, що надаються їм при реєстрації Власнику.
                    </li>
                    <li><strong>Логін</strong> - адреса Електронної пошти Користувача, що використовується для ідентифікації Користувача, і в поєднанні з Паролем дозволяє отримати доступ Користувача до всіх або окремих сервісів / модулів Сайту.
                    </li>
                    <li><strong>Пароль</strong> - буквено-цифровий код, згенерований Користувачем і наданий Власнику в процесі проходження реєстрації, що зберігається обома сторонами Угоди в таємниці від третіх осіб, і який використовується в поєднанні з логіном для отримання доступу Користувача до сервісів / модулів Сайту.
                    </li>
                    <li><strong>Реєстраційні дані Користувача</strong> - дані, добровільно зазначені Користувачем при проходженні реєстрації (ПІБ, контактний телефон, адреса електронної пошти). Дані зберігаються Власником і підлягають використанню виключно відповідно до Угоди та законодавства України.
                    </li>
                    <li><strong>Сайт</strong> - інформаційний проект Власника, розміщений в мережі Інтернет за адресою: <a href="/">www.apteka24.ua</a> і його дзеркал. Дозволяє за допомогою глобальної мережі Інтернет і різних електронних пристроїв переглядати в режимі онлайн різний Контент Сайту..
                    </li>
                    <li><strong>Контент Сайту</strong> - інформація, що розміщуються Власником, текстові матеріали, фотоматеріали, інші статичні зображення, відеоматеріали, які доступні до перегляду без стягнення з Користувача плати.
                    </li>
                    <li><strong>Особистий кабінет (Обліковий запис) Користувача</strong> - відомості, сформовані в результаті Реєстрації, необхідні в тому числі для ідентифікації Користувача і його доступу до окремих сервісів / модулів Сайту, включаючи, але не обмежуючись: Логін, Пароль.
                    </li>
                </ul>
                <h2>Загальні положення</h2>
                <p>
                    Угода встановлює правила і умови використання Сайту Користувачами, які після Реєстрації або без такої, здійснюють використання Сайту і його служб, стають Користувачами Сайту і послуг, що надаються Власником.
                </p>
                <p>
                    Ця Угода про використання Сайту укладається між Власником і будь-яким Користувачем. Звернення до будь-якого з розділів Сайту, як і розміщення на нього посилань, цитування та передрук Контенту Сайту, мають на увазі юридично зобов'язуючу згоду Користувача на повне і беззастережне дотримання умов і положень цієї Угоди.
                </p>
                <p>
                    Ця Угода не є договором. Власник Сайту залишає за собою право, як змінити цю Угоду, так і ввести нове. Подібні зміни вступають в силу з моменту їх розміщення на Сайті. Використання Користувачем матеріалів Сайту після зміни Угоди автоматично означає їх прийняття.
                </p>
                <p>
                    Якщо Ви (Користувач) не згодні дотримуватися Угоди, не використовуйте Сайт, а якщо Ви являєтеся зареєстрованим Користувачем, негайно припиніть використання Сайтуа.
                </p>
                <p>
                    Користувач зобов'язується регулярно знайомитися зі змістом Угоди з метою своєчасного ознайомлення з її змінами.
                </p>
                <p class="color-blue">
                    Призначенням Сайту є ознайомлення Користувача з контентом сайту і забезпечення інформаційної підтримки користувачів.
                </p>
                <p>
                    Забороняється будь-яке незаконне використання цього Сайту, розміщеної на ньому інформації та інших матеріалів.
                </p>
                <p>
                   Ніщо в Угоді не може тлумачитись або розумітися як встановлення між Власником та Користувачем агентських відносин, відносин товариства, відносин по спільній діяльності, відносин особистого найму або інших відносин, прямо не передбачених Угодою.
                </p>
                <p>
                    Власник має право поєднувати розміщені Користувачами на Сайті повідомлення або відгуки з інформацією рекламного характеру в формі графічних або текстових модулів (банерів).
                </p>
                <h2>Правила використання Інформаційних та інших матеріалів Сайту</h2>
                <p>
                    Будь-яке використання інформації та матеріалів Сайту допускається тільки з дозволу Власника Сайту. Під використанням Інформації Сайту мається на увазі — будь-яке відтворення, поширення, переробка й інші способи використання, передбачені Законом України «Про авторське право і суміжні права».
                </p>
                <p>
                    Будь-яке використання інформації та інших матеріалів, розміщених на Сайті, вимагає письмового дозволу Власника Сайту із зазначенням способу дозволеного використання, терміну використання, умов використання.
                </p>
                <h2>Права та обов'язки Користувача</h2>
                <p>
                    Користувач зобов'язується використовувати Сайт тільки в законних цілях, дотримуватися чинного законодавства України, а також права та законних інтересів Власника і правовласників, чий Контент розміщений на Сайті.
                </p>
                <p>
                    Користувач зобов'язаний не використовувати Сайт для Реєстрації більше одного облікового запису на одне і те ж обличчя
                <p>
                    Користувач зобов'язаний утримуватися від здійснення дій, спрямованих на дестабілізацію роботи Сайту, здійснення спроб несанкціонованого доступу до Сайту, а також від здійснення будь-яких інших дій, що порушують права Власника та / або третіх осіб.
                </p>
                <p>
                    Користувач зобов'язується не направляти через / за допомогою Сайту матеріали, які є рекламою будь-яких товарів або послуг, без отримання попередньої письмової згоди Власника. Користувач зобов'язується не використовувати Сайт для реклами або іншого стимулювання збуту будь-яких товарів і послуг..
                </p>
                <p>
                    Користувач не має права відтворювати, повторювати, копіювати, продавати, перепродавати, а також використовувати будь-яким способом для будь-яких комерційних цілей Сайт та (або) будь-які частини вмісту Сайту без згоди Власника..
                </p>
                <p>
                    Користувач має право припинити використання Сайту і відмовитися від створеного ним облікового запису, надіславши Власнику на адресу електронної пошти i&nbsp;
                    <a href="mailto:info@apteka24.ua">
                        info@apteka24.ua
                    </a> зі своєї адреси Електронної пошти, зазначеної при реєстрації, запит на видалення облікового запису з Сайту. Адміністратор видаляє обліковий запис Користувача протягом 10 (десяти) робочих днів після отримання такого запиту, що відповідає умовам, зазначеним вище.
                </p>
                <p>
                    Користувач зобов'язаний вживати належних заходів для забезпечення збереження даних свого Облікового запису Користувача (включаючи адресу електронної пошти, логін і пароль) і несе відповідальність за всі дії, вчинені на Сайті під його обліковим записом. У зв'язку із зазначеним, Користувач зобов'язаний здійснювати вихід зі свого Облікового запису (завершувати кожну сесію по кнопці «Вихід») перед переходом на сторонні сайти або закриттям браузера (Інтернет-оглядача). Користувач зобов'язаний негайно повідомити Власника про будь-які випадки доступу на Сайт третіми особами під Обліковим записом Користувача. Користувач не має права передавати, знижувати ціну, продавати, передавати в користування і т.п. Обліковий запис на Сайті третім особам без згоди Власника.
                </p>
                <p>
                    Користувач зобов'язаний періодично оновлювати персональну інформацію, яку він представив при Реєстрації, щоб забезпечити її точність, актуальність і повноту.
                </p>
                <p>
                    Користувач несе повну відповідальність за будь-які дії, вчинені ним з використанням його Облікового запису, а також за будь-які наслідки, які могли спричинити або спричинили подібне використання.
                </p>
                <p>
                    Користувач зобов'язаний використовувати отриману на Сайті інформацію виключно в законних і особистих некомерційних цілях, що не суперечать моральним принципам і загальновизнаним цінностям.
                </p>
                <p>
                    Користувач зобов'язується не намагатися змінювати або модифікувати ніяку частину Сайту, а також не використовувати Сайт і розміщений на ньому Контент в комерційних цілях.
                </p>
                <p>
                    Користувачі несуть відповідальність за власні дії у зв'язку зі створенням і розміщенням коментарів, повідомлень або відгуків на Сайті, а також у зв'язку з розміщенням інформації в Обліковому записі відповідно до чинного законодавства України.
                </p>
                <p>
                    Користувачеві при використанні Сайту забороняється завантажувати, зберігати, публікувати, поширювати і надавати доступ або іншим чином використовувати будь-яку інформацію, яка:
                </p>
                <ul>
                    <li>містить погрози, дискредитує, ображає, принижує честь і гідність чи ділову репутацію, або порушує недоторканність приватного життя інших користувачів або третіх осіб;
                    </li>
                    <li>є вульгарною або непристойною, містить нецензурну лексику, містить порнографічні тексти або тексти сексуального характеру;
                    </li>
                    <li>містить опис засобів і способів суїциду, будь-яке підбурювання до його здійснення;</li>
                    <li>пропагує і / або сприяє розпалюванню расової, релігійної, етнічної ненависті або ворожнечі, пропагує фашизм чи ідеологію расової переваги;
                    </li>
                    <li>пропагує злочинну діяльність або містить поради, інструкції або керівництва по здійсненню злочинних дій;
                    </li>
                    <li>містить інформацію обмеженого доступу, включаючи, але не обмежуючись, державну та комерційну таємницю, інформацію про приватне життя третіх осіб;
                    </li>
                    <li>містить рекламу;</li>
                    <li>носить шахрайський характер;</li>
                    <li>є інтелектуальною власністю третіх осіб, що не давали дозвіл Користувачу на її використання, а також порушує інші права та інтереси громадян, юридичних осіб або вимоги законодавства України.
                    </li>
                </ul>
                <p>
                    Користувач зобов'язаний виконувати інші обов'язки, встановлені Угодою, виконувати вказівки і вимоги Власника..
                </p>
                <h2>Права і обов'язки Власника</h2>
                <p>
                    Обов'язки Власника полягають виключно в забезпеченні надання технічної можливості отримання Користувачем демонстраційного доступу до Сайту в порядку, визначеному Угодою.
                </p>
                <p>
                    Власник залишає за собою право на свій власний розсуд змінювати або видаляти будь-яку опубліковану на Сайті інформацію, а також фото- та відеоконтент, і будь-які елементи, і складові частини Сайту, припиняти, обмежувати або забороняти доступ Користувача до всіх або до будь-якого з розділів / модулів сайту в будь-який час з будь-якої причини або без пояснення причин, з попереднім повідомленням або без такого (на розсуд Власника). При цьому Сторони погоджуються, що Власник не відповідає за будь-яку шкоду, яка може бути заподіяна Користувачеві такими діями.
                </p>
                <p>
                    Власник має право встановлювати будь-які обмеження у використанні Сайту, в будь-який час змінювати Угоду в односторонньому порядку без отримання згоди Користувача.
                </p>
                <p>
                    Власник має право здійснювати розсилання Користувачам повідомлень на Електронну пошту, вказану Користувачами при реєстрації, що містять організаційно-технічну або іншу інформацію. Якщо Власнику стане відомо, що Електронна пошта зареєстрованого Користувача не існує або є нечинною, Реєстрація відповідного Користувача буде припинена.
                </p>
                <p>
                    Власник має право надати Користувачеві можливість створення єдиного персонального Облікового запису. У разі створення Користувачем більше одного Облікового запису Власник залишає за собою право відмовити в створенні Користувачеві дублюючого Облікового запису та / або відмовити Користувачеві в використанні Сайту..
                </p>
                <p>
                    Власник має право розміщувати рекламну і / або іншу інформацію в будь-якому розділі сайту.
                </p>
                <p>
                    Власник зобов'язаний не здійснювати наступних дій:
                </p>
                <ul>
                    <li>Розміщувати будь-які файли, які містять або можуть містити віруси та інші шкідливі програми;
                    </li>
                    <li>Описувати або пропагувати злочинну діяльність, розміщувати інструкції або керівництва по здійсненню злочинних дій;
                    </li>
                    <li>Розміщувати на Сайті будь-яку інформацію, що порушує виключні права користувачів або третіх осіб.
                    </li>
                </ul>
                <p>
                    Власник має право не займатися попередньою модерацією або цензурою коментарів і відгуків користувачів і вживати заходів щодо захисту прав та інтересів осіб і забезпечення дотримання вимог законодавства України тільки після звернення зацікавленої особи до Власника в установленому Власником порядку і / або інших випадках, передбачених Угодою.
                </p>
                <p>
                    Власник не несе відповідальність за отримання доступу третіми особами до особистої інформації користувачів, якщо такий доступ став можливий з вини користувачів або в результаті неправомірних дій третіх осіб.
                </p>
                <h2>Персональні дані</h2>
                <p>
                    Перед заповненням своїх персональних даних, Користувач дає свою згоду Власнику на збір і обробку (накопичення, зберігання, адаптування, відновлення, використання, поширення, знеособлення і знищення) зазначених даних, а саме: прізвище, ім'я та по батькові, логін і пароль доступу електронної пошти, номери контактних телефонів, адреси, дати і місця народження, ідентифікаційного номера, стать, громадянство; країна проживання, місце роботи, посада) з метою забезпечення реалізації відносин у сфері захисту прав споживачів, у сфері реклами і маркетингових досліджень, а також дає свою згоду на передачу (поширення) його даних іншим транспортно-експедиторським і кур'єрським організаціям, будь-яким Банкам і / або фінансовим установам і іншим третім особам (без обмеження) на розсуд ТОВ «МІС-Cервіс». Дане положення діє без обмеження терміну дії.
                </p>
                <p>
                    Джерелом збору персональних даних є інформація, свідомо і добровільно надана Користувачем як суб'єктом персональних даних в цілях використання сервісів Сайту.
                </p>
                <p>
                    Власником і розпорядником Ваших персональних даних є ТОВ «МІС-Cервіс» (код ЄДРПОУ 43826536). Місцезнаходження: 49100 м. Дніпро, пр.Героїв, д. 11Л, каб. 321. База персональних даних «Клієнти» знаходиться за адресою ТОВ «МІС-Cервіс»: 49100 м. Дніпро, пр.Героїв, д. 11Л, каб. 321.
                </p>
                <p>
                    Суб'єкт персональних даних відповідно до Закону України «Про захист персональних даних», має право:
                </p>
                <ul>
                    <li>знати про джерела збору, місцезнаходження своїх персональних даних, мету їх обробки, місцезнаходження або місце проживання (перебування) власника чи розпорядника персональних даних або дати відповідне доручення щодо отримання цієї інформації уповноваженим ним особам, крім випадків, встановлених законом;
                    </li>
                    <li>отримувати інформацію про умови надання доступу до персональних даних, зокрема інформацію про третіх осіб, яким передаються його персональні дані;
                    </li>
                    <li>на доступ до своїх персональних даних;</li>
                    <li>отримувати не пізніше, ніж за тридцять календарних днів з дня надходження запиту, крім випадків, передбачених законом, відповідь про те, чи обробляються або зберігаються його персональні дані, а також отримувати зміст його персональних даних, які зберігаються;
                    </li>
                    <li>висувати вмотивовану вимогу власнику персональних даних із запереченням проти обробки своїх персональних даних;
                    </li>
                    <li>висувати вмотивовану вимогу щодо зміни або знищення своїх персональних даних будь-яким власником і розпорядником персональних даних, якщо ці дані обробляються незаконно чи вони недостовірні;
                    </li>
                    <li>на захист своїх персональних даних від їх незаконної обробки та випадкової втрати, знищення, пошкодження у зв'язку з умисним приховуванням, ненаданням чи несвоєчасним їх наданням, а також на захист від надання відомостей, що є недостовірними чи ганьблять честь, гідність та ділову репутацію фізичної особи;
                    </li>
                    <li>звертатися зі скаргами на обробку своїх персональних даних до органів державної влади та посадових осіб, які уповноважені забезпечувати захист персональних даних, або до суду;
                    </li>
                    <li>застосовувати засоби правового захисту в разі порушення законодавства про захист персональних даних;
                    </li>
                    <li>вносити застереження про обмеження прав на обробку своїх персональних даних при наданні згоди;
                    </li>
                    <li>відкликати згоду на обробку персональних даних; знати механізм автоматичної обробки персональних даних;
                    </li>
                    <li>на захист від автоматизованого рішення, яке має для нього правові наслідки.</li>
                </ul>
                <p>
                    Користувач, погоджуючись на збір і обробку своїх персональних даних, підтверджує, що обізнаний про включення інформації про нього до бази персональних даних з вищезазначеною метою, про свої права, визначені Законом України «Про захист персональних даних», а також про осіб, яким його дані передаються для виконання вищезазначеної мети.
                </p>
                <p>
                    Користувач підтверджує, що повністю розуміє цільове призначення Сайту, обробки його даних.
                </p>
                <p>
                    Ознайомитися з політикою конфіденційності та захисту персональних даних можливо за&nbsp;
                    <a href="https://www.apteka24.ua/terms/">
                        посиланням
                    </a>
                </p>
                <h2>Відповідальність. Обмеження відповідальності</h2>
                <p>
                    Користувач прямо погоджується, що використовує Інформаційні матеріали про Лікарські засоби, розміщені на Сайті <a href="/">www.apteka24.ua</a>, що служать для ознайомлення і не можуть використовуватися як рекомендація щодо застосування або як джерело інформації з самолікування і можуть бути застосовані виключно за рецептом лікаря і під лікарським наглядом, якщо інше прямо не передбачено чинним законодавством України.
                </p>
                <p>
                    Сайт не призначений для Користувачів, які не досягли повноліття і для недієздатних Користувачів. У разі випадкового візиту на Сайт, такі Користувачі зобов'язані покинути його. Власник сайту не несе відповідальності за будь-які небажані наслідки в разі невиконання цієї вимоги Користувачами.
                </p>
                <p>
                    Користувачі Сайту з юрисдикцій, інших, ніж Україна, повинні використовувати Інформацію про Лікарські засоби відповідно до правил, які діють на території таких юрисдикцій.
                </p>
                <p>
                    Власник Сайту не несе відповідальності за можливу шкоду, завдану вашому здоров'ю, в зв'язку з самостійним використанням Інформації, розміщеної на Сайті. Користувач повністю відповідає за будь-яке неправильне трактування, яке може виникнути внаслідок перегляду, читання або копіювання матеріалів, що містяться на Сайті і таким чином ніяка юридична або фізична особа не може бути відповідальна за використання згаданих матеріалів. Ні в якому разі відповідальність за наслідки, які прямо або опосередковано спричинені використанням Контенту Сайту, не може покладатися на Власника Сайту і бути підставою для судового переслідування.
                </p>
                <p>
                    Послуги Сайту надаються за принципом «як є» без гарантій будь-якого роду, як прямих, так і непрямих. Користувач в добровільному порядку відмовляється від судового і адміністративного переслідування Власника Сайту і будь-яких вимог про відшкодування можливої шкоди, заподіяної здоров'ю Користувача.
                </p>
                <p>
                    Контент Сайту надається без гарантії того, що він не може містити помилки. Власник Сайту має право змінювати Контент Сайту, включаючи без всяких обмежень переміщення або видалення Контенту Сайту на свій власний розсуд, за будь-якої причини або без причини, в будь-який час і без попереднього оголошення про такі зміни.
                </p>
                <p>
                    Власник гарантує не розголошувати дані Користувача, отримані при реєстрації, за винятком випадків, передбачених законодавством України.
                </p>
                <p>
                    Користувач повністю відповідальний за збереження свого Логіна і Пароля і за збитки, які можуть виникнути внаслідок їх втрати або несанкціонованого використання його Облікового запису. Власник не несе відповідальності і не відшкодовує збитки, що виникли внаслідок несанкціонованого використання третіми особами Логіна і Пароля Облікового запису Користувача. Всі дії, вчинені відвідувачем, який авторизувався за допомогою Логіна і Пароля Користувача, розглядаються як дії Користувача. Користувач несе повну відповідальність за всі дії, вчинені авторизованою особою від його імені.
                </p>
                <p>
                    Власник не несе відповідальності за будь-які збитки електронним пристроям Користувача або іншої особи, мобільним пристроям, будь-якому іншому обладнанню або програмному забезпеченню, що викликані або пов'язані з використанням Сайту.
                </p>
                <p>
                    Власник не несе відповідальності перед Користувачем або будь-якими третіми особами за дії Користувача на Сайті.
                </p>
                <p>
                    Власник не несе відповідальності за порушення Користувачем Угоди і залишає за собою право на свій власний розсуд, а також при отриманні інформації від будь-яких третіх осіб про порушення Користувачем Угоди або прав та інтересів третіх осіб, змінювати (модерувати) або видаляти будь-яку опубліковану Користувачем інформацію, а також призупиняти, обмежувати або припиняти доступ Користувача до всіх або до будь-якого з розділів Сайту в будь-який час з будь-якої причини або без пояснення причин, з попереднім повідомленням або без такого, не відповідаючи за будь-яку шкоду, яка може бути заподіяна Користувачеві такою дією.
                </p>
                <p>
                    У разі пред'явлення третіми особами претензій до Власника, пов'язаних з використанням Користувачем Сайту, Користувач зобов'язується своїми силами і за свій рахунок врегулювати розміщення в ній інформації з третіми особами, захистивши Власника від можливих збитків і розглядів.
                </p>
                <p>
                    Сайт може містити посилання на інші ресурси мережі Інтернет. Користувач визнає і погоджується з тим, що Власник не контролює і не несе ніякої відповідальності за доступність цих ресурсів і за їх зміст, а також за будь-які наслідки, пов'язані з використанням цих ресурсів. Будь-які переходи по посиланнях, які здійснюються Користувачем, останній вчиняє на свій страх і ризик.
                </p>
                <p>
                    Власник Сайту не гарантує безперебійної та безпомилкової роботи Сайту; також не гарантовано, що такими будуть і результати, отримані в ході використання Сайту, так і точність, і можливість застосування його матеріалів.
                </p>
                <h2>Зовнішні посилання</h2>
                <p>
                    Відповідно до умов та положень, викладених в цій Угоді, Власник надає Користувачеві невиключну, обмежену, відкличну, безоплатну ліцензію на розміщення гіпертекстового довідкового посилання (далі по тексту — "Посилання") на Сайт виключно в некомерційних цілях, що не виходять за рамки з'єднання сайту Користувача з Сайтом.
                </p>
                <p>
                    Користувач не має права:
                </p>
                <ul>
                    <li>розміщувати Посилання або користуватися ним таким чином, який приведе до виведення Сайту або будь-якого його елемента на екран у вигляді окремого кадру у вікні, або до появи асоціацій з будь-якого роду рекламою або спонсорською програмою, яка не має стосунку до Сайту, або до іншого включення інформаційного наповнення сайту до складу якого б то не було стороннього сайту;
                    </li>
                    <li>розміщувати або використовувати вбудовані посилання на який-небудь файл даних, що входить до складу Сайту;
                    </li>
                    <li>видозмінювати будь-який елемент Сайту, блокувати чи іншим чином перешкоджати його відображенню;
                    </li>
                    <li>посилатися на Сайт через будь-який сторонній уніфікований покажчик ресурсів (URL) або сайт-дублер;
                    </li>
                    <li>розміщувати посилання на Сайт в тому випадку, якщо вміст сайту користувача виглядає в очах розсудливої особи непристойним, наклепницьким, що містить в собі домагання, глибоко образливим, зловмисним або будь-яким іншим чином незаконним і / або таким, що порушує охоронювані законодавством права.
                    </li>
                </ul>
                <h2>Торгові марки</h2>
                <p>
                    Зареєстровані торгові марки, знаки для товарів і послуг, комерційні найменування, що згадуються на Сайті, є власністю їх відповідних власників.
                </p>
                <h2>Заключні положення</h2>
                <p>
                    Угода укладається на невизначений термін і поширює свою дію на Користувачів, які здійснюють доступ до Сайту і його використання, як до дати опублікування Угоди, так і після дати її опублікування на Сайті.
                </p>
                <p>
                    Якщо з тих чи інших причин будь-які з умов Угоди є недійсними або не мають юридичної сили, це не впливає на дійсність або застосовність інших умов Угоди.
                </p>
                <p>
                    Угода і відносини між Власником та Користувачем регулюються відповідно до законодавства України. Сторони Угоди зобов'язуються підкорятися виключній юрисдикції судів України при виникненні спірних питань юридичного характеру, пов'язаних з Угодою або Сайтом.
                </p>
                <p>
                    Сторони погодилися, що всі суперечки, що виникають у відносинах Сторін, регулюються цією Угодою, повинні вирішуватися в компетентному суді за місцем знаходження Власника з обов'язковим дотриманням досудового претензійного порядку врегулювання спорів, встановленого Угодою.
                </p>
                <p>
                    Якщо Користувач не до кінця розуміє умови цієї Угоди або не згоден з будь-яким з пунктів, викладених в Угоді, він повинен покинути сторінки Сайту.
                </p>`
    },
    orderReturn: {
        title: "Умови повернення товарів",
        content: `
                <p>
                    Відповідно до
                    <a
                        href="https://zakon.rada.gov.ua/laws/show/z0782-05#Text"
                        target="_blank"
                    >
                        наказу МОЗ від 19 липня 2005 р. № 360
                    </a>
                    та
                    <a
                        href="https://zakon.rada.gov.ua/laws/show/172-94-%D0%BF#Text"
                        target="_blank"
                    >
                        Постанови КМУ від 19.03.1994 р. № 172
                    </a>: 
                    «Лікарські засоби та вироби медичного призначення належної якості, відпущені з аптек та їх структурних підрозділів, поверненню не підлягають».
                </p>
                
                <p>
                    Відповідно до <a
                        href="https://zakon.rada.gov.ua/laws/show/1023-12#Text"
                        target="_blank"
                    >
                        ст. 8. Закону України «Про захист прав споживачів»
                    </a>: 
                    «У разі виявлення протягом встановленого гарантійного строку істотних недоліків, які виникли з вини виробника товару (продавця, виконавця), або фальсифікації товару, підтверджених за необхідності висновком експертизи, споживач, в порядку та у строки, що встановлені законодавством, і на підставі обов’язкових для сторін правил чи договору, має право за своїм вибором вимагати від продавця або виробника: 
                </p>
                
                <ul>
                    <li>
                        розірвання договору та повернення сплаченої за товар грошової суми;                                             
                    </li>
                                    
                    <li>
                        вимагати заміни товару на такий же товар або на аналогічний, з числа наявних у продавця (виробника), товар».
                    </li>                
                </ul>
                
                <p>
                    Для повернення лікарського засобу чи виробу медичного призначення НЕналежної якості, необхідно надати фіскальний чек та доказ того, що лікарський засіб неякісний — висновок експертизи, Розпорядження Держлікслужби про заборону обігу лікарського засобу тощо. Офіційним органом у сфері контролю якості лікарських засобів є
                    <a
                        href="https://www.dls.gov.ua/"
                        target="_blank"
                    >
                        Державна служба України з лікарських засобів та контролю за наркотиками 
                    </a> 
                    (Держлікслужба).
                </p>
                
                <p>
                    Відповідно
                    <a
                        href="https://zakon.rada.gov.ua/laws/show/1002-2021-%D0%BF#Text"
                        target="_blank"
                    >
                        Постанови КМУ від 22.09.2021 р. № 1002
                    </a> 
                    «Споживач має право відмовитися від доставленого лікарського засобу під час отримання замовлення та має право вимагати повернення коштів від ліцензіата, який здійснив продаж такого лікарського засобу у випадку, якщо:
                </p>
                
                <ul>
                    <li>
                        пошкоджено первинну та/або вторинну упаковку лікарського засобу;
                    </li>
                    
                    <li>
                        минув термін придатності лікарського засобу;
                    </li>
                    
                    <li>
                        уповноваженим органом опублікована заборона реалізації та застосування лікарського засобу;
                    </li>
                    
                    <li>
                        доставлене замовлення не відповідає замовленому за кількістю або складом, найменуванням, дозуванням, формою випуску, ціною.
                    </li>
                </ul>
                
                <p>
                    Споживач має право повернути його співробітнику служби доставки ліцензіата, який здійснив доставку, без оплати доставленого лікарського засобу та/або послуг з його доставки та/або вимагати належного виконання замовлення».
                </p>
                `
    },
    warranty: {
        title: "Гарантії якості",
        content: `
                <p>
                    Як електронна медична інформаційна система ми бачимо своїм завданням організацію вибору та доставки якісної продукції аптечного асортименту клієнту. Тому ми співпрацюємо з надійними аптеками-партнерами, яким товари медичного призначення постачають лише великі та перевірені дистриб'ютори в Україні.
                </p>

                <p>
                    У свою чергу наші аптеки-партнери здійснюють перевірку всіх товарів, що надходять, через систему трирівневого контролю:
                </p>
                
                <ul>
                    <li>
                        кожен етап реалізації лікарських засобів супроводжується чітким контролем температурного режиму та вологості (перша перевірка відбувається при надходженні продукції на склад, друга – при виході зі складу в аптеку, третя – при прийомі товару в аптеці);
                    </li>
                    
                    <li>
                        в аптеках відбувається відстеження продукції з терміном придатності, що закінчується, товар з таким терміном вилучається заздалегідь з реалізації;
                    </li>
                    
                    <li>
                        при надходженні продукції в аптеки-партнери уповноважена особа проводить вхідний контроль, 
                        перевіряє лікарські засоби на відсутність у 
                        <a href="http://pub-mex.dls.gov.ua/QLA/DocList.aspx" target="_blank">Реєстрі документів якості лікарських засобів</a>, 
                        обіг яких заборонено в Україні, 
                        а також проводить візуальний контроль за такими показниками, як «Маркування», «Упаковка», 
                        «Термін придатності».
                    </li>
                </ul>

                <p>
                    До того ж у кожному аптечному закладі, з яким ми співпрацюємо, покупець може попросити надати сертифікати якості на продукцію та інформацію про виробника чи дистриб'ютора — і ці документи будуть надані.
                </p>
                `,
        qualityAssurance: `Гарантії якості підтверджують сертифікати GDP`
    },
    loyaltyRules: {
        title: `Правила участі у бонусній Програмі лояльності «Морквинки»`,
        description: `Дані Правила для прийняття участі в бонусній Програмі лояльності «Морквинки» (далі — «Правила») визначають і встановлюють офіційні умови для участі в бонусній Програмі «Морквинки» (далі — «Програма»), які встановлюють період, умови, а також порядок участі в програмі. У створення справжніх правил покладено Цивільний кодекс України, Закон України «Про інформацію», Закон України «Про захист персональних даних», а також інші нормативно-правові акти України та внутрішні положення ТОВ «МІС-Cервіс»`,
        terms: {
            title: `Визначення термінів Правил участі в Програмі лояльності`,
            list: `
                <li>«Організатор» Програми — ООО «МІС-Cервіс», 49100, м. Дніпро, пр.Героїв, д. 11Л, каб. 321.</li>
                <li>«Програма» — це програма лояльності на apteka24.ua, що передбачає використання бонусів, метою якої визначається заохочення постійних покупців, яким надаються спеціальні умови для придбання товарів на сайті apteka24.ua.</li>
                <li>«Учасник» Програми — брати участь в Програмі можуть тільки дієздатні фізичні особи, які досягли повноліття. Для того, щоб взяти участь у Програмі, Учасник надає свою згоду наступним чином: реєструючись або здійснюючи покупки на сайті apteka24.ua відповідно до чинних Правил. Участь такої особи має бути підтверджена Організатором.</li>
                <li>«Обліковий запис за номером мобільного телефону» (обліковий запис по НМТ) — обліковий запис Учасника в інформаційній системі Організатора, що є віртуальним. В системі номер облікового запису завжди відповідає українському номеру мобільного телефону Учасника.</li>
                <li>«Кешбек» — це бонуси, які повертаються на «Рахунок» Учасника в рамках програми лояльності «Морквинки» за покупки на сайті apteka24.ua. Також бонуси нараховуються у вигляді заохочення за додаткові активності в рамках програми лояльності «Морквинки», передбачені Організатором. Бонуси «Кешбек» активуються для списання на 15-ий день після того, як будуть нараховані.</li>
                <li>«Купони» — так називаються спеціалізовані особисті промо-пропозиції для учасників програми лояльності «Морквинки» з обмеженим терміном дії і які є додатковим заохоченням. Купони можуть бути надані Учаснику як у вигляді автоматичних нарахувань на його особистий рахунок, так і у вигляді спеціальних текстових кодів. У першому випадку, якщо купон є автоматичним нарахуванням на рахунок Учасника, то він активується відразу ж після того, як Учасник виконає умови, необхідні для його списання. У другому випадку, коли купон надається у вигляді текстового коду, Учаснику, щоб скористатися даним купоном, необхідно ввести текстовий код у момент оформлення замовлення на сайті apteka24.ua в процесі здійснення покупки. </li>
                <li>«Рахунок» — в інформаційній системі Організатора є сукупністю даних про процес нарахування і списання бонусів згідно з обліковим записом Учасника.</li>
                <li>«Заохочення» — так називається можливість Учасника використовувати Бонуси у якості знижки підчас придбання товарів (крім деяких обмежень на покупку товарів, встановлених Організатором) на сайті apteka24.ua відповідно до даних Правил Програми. До заохочень відносяться: бонуси, купони та подарунки, передбачені організаторами програми. </li>
                <li>«Транзакція» — це операція, що проводиться Учасником і в результаті якої відбувається нарахування або ж списання Бонусів з Рахунку в інформаційній системі Організатора.</li>
                <li>«Канали комунікації Програми» — такими каналами є безпосередньо сайт apteka24.ua, гаряча лінія 0800302244 та інші засоби комунікації, які застосовуються для контакту та комунікації між Учасником та Організатором.</li>
                `
        },
        generalProvisions: {
            title: `Загальні положення Програми лояльності`,
            list: `
                <li>Програму лояльності «Морквинки» необхідно вважати договором приєднання, який потрібно трактувати згідно зі статтею 634 Цивільного кодексу України.</li>
                <li>Програма лояльності не є азартною грою або іншою послугою у сфері грального бізнесу.</li>
                <li>Програма лояльності «Морквинки» діє виключно тільки на офіційному сайті — apteka24.ua.</li>
            `
        },
        conditions: {
            title: `Умови, необхідні для участі в Програмі лояльності`,
            list: `
                <li>Учасником Програми лояльності може стати тільки фізична особа, яка зареєструвалася на сайті apteka24.ua, обов'язково вказала номер свого мобільного телефону від українського GSM-оператора та/або здійснила покупку товарів на сайті apteka24.ua незалежно від суми оплати. Всі дії повинні бути здійснені відповідно до умов чинних Правил.</li>
                <li>Програма може бути використана виключно фізичними особами, які досягли повноліття. Бонуси Програми заборонено продавати, за них неможливо отримати компенсацію у вигляді грошових коштів, а також їх неможливо відчужувати ніяким іншим способом.</li>
                <li>Юридичні особи жодним чином не можуть брати участь у Програмі.</li>
                <li>Основним ідентифікатором Учасника Програми в інформаційній системі Організатора є віртуальний обліковий запис, що відповідає номеру мобільного телефону Учасника від українського GSM-оператора (обліковий запис по НМТ).</li>
                <li>Інформацію про умови Програми можна отримати на сайті apteka24.ua або через Канали комунікації Програми.</li>
                <li>Датою початку участі в Програмі є дата активації облікового запису за номером мобільного телефону в інформаційній системі Організатора Учасником Програми згідно з цими Правилами.</li>
                <li>Обліковий запис у Програмі лояльності «Морквинки», який створено відповідно до номера мобільного телефону Учасника, у якості ідентифікатора Учасника Програми в системі Організатора дійсний тільки протягом терміну дії Програми.</li>
                <li>Обліковий запис Учасника за номером мобільного телефону можна заблокувати при необхідності в наступних випадках: при втраті мобільного телефону, при втраті sim-карти, а також з причини пошкодження sim-карти. Для блокування, а також для її розблокування Учаснику необхідно звернутися до Організатора Програми на електронну пошту info@apteka24.ua або ж зателефонувати на гарячу лінію за номером 0800302244 з відповідним зверненням. Учаснику потрібно вказати своє прізвище та ім'я, номер мобільного телефону, причину блокування облікового запису по НМТ, а також пройти ідентифікацію особи відповідно до одного із запропонованих співробітником компанії «Apteka24.ua» способом.</li>
                <li>Для розблокування облікового запису за номером мобільного телефону необхідно звернутися до Організатора Програми на електронну пошту info@apteka24.ua з відповідною заявкою на розблокування облікового запису по НМТ. Розблокування можливо тільки тоді, коли інформаційні дані фізичної особи (ПІБ, дата народження, номер мобільного телефону), що подає заявку на розблокування, збігаються з даними, які були вказані Учасником при реєстрації в інформаційній системі Програми.</li>
                <li>Організатор Програми після зняття блокування облікового запису не несе відповідальності за всі операції, які проводилися на рахунку до моменту блокування облікового запису.</li>
                <li>У разі зміни номера мобільного телефону Учаснику необхідно звернутися до Організатора Програми на електронну пошту info@apteka24.ua з відповідним зверненням. Для того, щоб змінити номер облікового запису, потрібно вказати колишній номер телефону, а також новий номер мобільного телефону. При цьому в інформаційній системі Організатора для даного Учасника дезактивується попередній обліковий запис за колишнім номером мобільного телефону та активується новий обліковий запис за новим номером мобільного телефону. Обов'язково відбувається відповідне збереження стану рахунку.</li>
                <li>У тому випадку, якщо Учасник несвоєчасно проінформував Організатора про те, що він змінив номер мобільного телефону, Організатор Програми не несе відповідальності за всі ті операції, які могли проводитися на рахунку Учасника до надходження відповідного інформування про зміну номера телефону.</li>
            `
        },
        organizerResponsibilities: {
            title: `Обов'язки і права Організатора Програми лояльності`,
            list: `
                <li>Організатор залишає за собою абсолютне право в будь-який момент припинити Програму, скасувати або ж змінити умови Програми. При закритті Програми всі Бонуси, які встиг набрати учасник, можуть бути використані ним протягом 30 (тридцяти) календарних днів після розміщення відповідного оголошення на сайті про те, що програма закривається.</li>
                <li>
                    Організатор в будь-який момент має право відмовити клієнту в активації облікового запису за його номером мобільного телефону, видалити або ж припинити дію облікового запису при наступних обставинах, які можуть бути ширше зазначених:
                    <ul>
                        <li>використання або спроба використання облікового запису тим способом, який не передбачений умовами Програми;</li>
                        <li>при виникненні будь-якої обґрунтованої підозри в тому, що Учасник вчиняє зловживання щодо своєї участі в Програмі;</li>
                        <li>якщо Учасник не проводить ніяких операцій на своєму обліковому записі протягом 36 місяців;</li>
                        <li>будь-які інші вагомі обставини, які Організатор може вважати значущими для відмови в активації або для припинення активності облікового запису.</li>
                    </ul>
                </li>
                <li>Організатор не несе відповідальності за будь-які втрати або збитки, які можуть виникати в результаті подібних дій.</li>
                <li>Організатор має право списувати з рахунку Учасника Програми Бонуси, нарахування яких було помилковим у зв'язку з неправильною роботою ПО (програмного забезпечення): наприклад, якщо Бонуси були нараховані в зв'язку з покупкою, яка була скасована, або в разі повернення товару, а також тоді, коли Учасник буде викритий в шахрайстві і/або зробить недобросовісні дії з Обліковим записом або зі своїм бонусним балансом.</li>
            `
        },
        registration: {
            title: `Процедура реєстрації в програмі`,
            list: `
                <li>Реєстрація в Програмі здійснюється наступним чином: покупець, стаючи Учасником Програми, реєструється за номером мобільного телефону або ж робить покупку на сайті apteka24.ua. Сума покупки може бути будь-якою.</li>
                <li>Після реєстрації та після того, як відбудеться передача даних про покупку клієнта в інформаційну систему Організатора, для клієнта активується обліковий запис за номером мобільного телефону.</li>
            `
        },
        bonusesAccrual: {
            title: `Як відбувається нарахування бонусних заохочень`,
            list: `
                <li>Перед тим, як Учасник проведе будь-яку транзакцію для оплати товарів, він повинен вказати особистий мобільний номер. Після цього відбувається нарахування бонусного заохочення через інформаційну систему Організатора на рахунок Учасника.</li>
                <li>Існують спеціальні бонуси, які можуть бути нараховані Учаснику Організатором при проведенні рекламних кампаній, спеціальних акцій і пропозицій від Програми. Такі бонусні нарахування відрізняються обмеженим терміном дії, який відповідає термінам, в період яких здійснюється акція. Після того, як акція буде закінчена, дані бонуси зникають з рахунку Учасника та більше він не зможе ними скористатися.</li>
                <li>Бонуси будуть анульовані в тому випадку, якщо відбувається повернення раніше придбаного товару, за покупку якого були нараховані бонуси. Якщо товар підлягає процедурі обміну, то бонуси, нараховані за його придбання, анулюються і нараховуються на той товар, який купується. Обмін і повернення товару може бути проведений тільки в рамках норм, встановлених Законом України «Про захист прав споживачів».</li>
                <li>Призупинення повернення грошових коштів може бути проведено Організатором в тому випадку, якщо в результаті проведення транзакції у Учасника виникає негативний баланс на бонусному рахунку. Це призводить до того, що період розгляду заяви подовжується на 14 календарних днів. Якщо виникає негативний баланс на бонусному рахунку Учасника, то Учасник повинен компенсувати розмір наданої знижки в грошовому еквіваленті.</li>
                <li>Нарахування бонусів за придбання товару на сайті apteka24.ua, на який поширюються умови Програми лояльності, здійснюється після проведення оплати даної покупки. Бонуси активуються і стають можливими для списання на 15-ий день після оплати товару.</li>
                <li>При здійсненні покупки на сайті apteka24.ua Учасник повинен перевірити правильність зазначених деталей замовлення, а також номер свого мобільного телефону. При виникненні спірних питань для їх успішного вирішення Учасник повинен звернутися до представника Організатора, повідомивши йому номер замовлення і пред'явивши, в разі необхідності, оригінал фіскального чека.</li>
                <li>Організатор залишає за собою право внесення змін до <a href="${links.loyaltyBonusRules}">умов нарахування Бонусів</a> без повідомлення Учасників Програми.</li>
                <li>Бонуси можуть бути нараховані на рахунок Учасника Програми тільки за умови, що для цього існують всі необхідні технічні та/або інші можливості: є в наявності інтернет, немає перебою з електроенергією, правильно функціонує програмне забезпечення. Якщо дані умови не дотримані або їх дотримання неможливо для нарахування бонусів, то бонуси будуть нараховані на рахунок Учасника після того, як будуть відновлені всі необхідні можливості.</li>
            `
        },
        bonusesUsage: {
            title: `Правила використання заохочень (бонусів)`,
            list: `
                <li>Бонуси стають доступними для використання після того, як були нараховані на бонусний рахунок Учасника, крім Бонусів, умови яких визначаються відповідною Акцією.</li>
                <li>Термін дії бонусів на бонусному рахунку Учасника становить 180 календарних днів з моменту їх активації, крім Бонусів, умови яких визначаються відповідною Акцією.</li>
                <li>Всі бонуси, накопичені Учасником на бонусному рахунку і доступні до списання, Учасник може використовувати для економії та оплати товарів у якості знижки, однак оплатити бонусами можна не більше 50% від вартості товару, який буде купуватися згідно з Програмою на сайті apteka24.ua (виняток становлять тільки обмеження на придбання товарів, встановлені Організатором).</li>
                <li>Оплата товарів шляхом списання бонусів (у разі, якщо є активовані бонуси на рахунку Учасника) можлива тільки тоді, коли Учасник пройде процедуру верифікації за номером мобільного телефону. Для цього Учаснику на його мобільний номер приходить або SMS-повідомлення, або Viber-повідомлення від альфа-імені apteka24.ua c чотиризначним кодом підтвердження, який необхідний для списання бонусів. Учасник вводить даний код в спеціальне поле форми, що з'являється в момент оформлення замовлення з використанням бонусів. Термін дії коду підтвердження — доба (24 години). Даний код може використовуватися тільки один раз.</li>
                <li>Учасник може використовувати Бонуси тільки тоді, коли для цього є всі необхідні технічні та/або інші умови: є в наявності інтернет-з'єднання, безперебійна електроенергія, коректно працює програмне забезпечення.</li>
                <li>Використання Бонусів з Рахунку Учасника у вигляді списання здійснюється наступним чином: 1 бонус умовно прирівнюється до 1 гривні знижки при купівлі товару за умовами Програми.</li>
                <li>Організатор залишає за собою право вносити зміни до переліку товарів, під час придбання яких Учасник може використовувати Бонуси, при цьому попереднє повідомлення Учасників не обов'язкове.</li>
                <li>Відповідно до кількості набраних бонусів на рахунку Учасника, Організатор надає Учаснику право отримати знижку при купівлі товару за заявленим умовам.</li>
                <li>Організатор Програми визначає і затверджує товари, купуючи які можна використовувати накопичені Бонуси.</li>
                <li>Бонуси можна використовувати як знижку (економію) до вартості товару, але не більше 50% від вартості товару, який купується в рамках і за умовою Програми.</li>
                <li>Бонуси не є і не можуть бути засобом платежу, не є еквівалентом будь-якого виду валюти або цінних паперів.</li>
                <li>Доступні до списання Бонуси, накопичені Учасником в рамках Програми, жодним чином не можуть бути переведені в грошовий еквівалент і видані Учаснику готівковими коштами.</li>
                <li>Організатор Програми не несе відповідальності за сплату Учасником податків і виконання інших фінансових зобов'язань, пов'язаних з участю в Програмі. Всі оплати здійснюються Учасником Програми самостійно і власним коштом.</li>
                <li>Бонуси, які Учасник не використав протягом 180 днів з моменту активації і/або під час проведення Акції, анулюються і списуються з рахунку Учасника. Списання бонусних заохочень відбувається в хронологічному порядку, починаючи від дати їх активації.</li>
                <li>Організатор залишає за собою право внесення змін до <a href="${links.loyaltyBonusRules}">умов списання Бонусів</a> без повідомлення Учасників Програми.</li>
            `
        },
        violationConsequences: {
            title: `Наслідки порушення Учасником Правил Програми лояльності `,
            list: `
                <li>
                    Організатор залишає за собою право перервати участь у Програмі будь-якого Учасника без повідомлення шляхом блокування облікового запису у випадках несумлінного використання облікового запису, якщо Учасник:
                    <ul>
                        <li>не дотримується чинних Правил участі;</li>
                        <li>надає недостовірні дані або дезінформацію;</li>
                        <li>бере участь у схемах шахрайства в рамках дії Програми.</li>
                    </ul>
                </li>
                <li>У разі викриття Учасника в порушеннях, зазначених пункті 8.1., його участь в Програмі припиняється, Обліковий запис блокується, а накопичена бонусна сума анулюється.</li>
                <li>У разі виникнення претензій, пов'язаних з блокуванням Облікового запису, припиненням участі в Програмі та анулюванням бонусних накопичень, для розблокування Облікового запису клієнт повинен подати заявку на електронну пошту info@apteka24.ua і пред'явити чеки на покупки, здійснені за допомогою його Облікового запису. Після розгляду претензії Організатор приймає рішення про можливість розблокування облікового запису.</li>
            `
        },
        otherConditions: {
            title: `Інші умови `,
            list: `
                <li>Програма лояльності «Морквинки», що проводиться apteka24.ua, є довгостроковою.</li>
                <li>
                    <p>Правила Програми строго регулюються чинним законодавством України. При розрахунках з Учасником Організатор має право тимчасово відмовити Учаснику в нарахуванні та/або використанні Бонусів, але тільки в тому випадку, якщо на момент звернення Учасника щодо використання Бонусів, в Організатора відсутні технічні чи інші можливості для нарахування, активації або списання.</p>
                    <p>Учасник погоджується з усіма приведеними правилами Програми, якщо він робить будь-яку активну дію на сайті apteka24.ua (наприклад реєстрація, покупка, залишення відгуку і т.д.)</p>
                </li>
                <li>Організатор гарантує, що під час отримання, зберігання, обробки та використання отриманої від Учасника персональної інформації він буде дотримуватися положень Правил та норм чинного законодавства України. У зв'язку з цим Учасник підтверджує, що він ознайомився і повністю (тобто, однозначно) погодився з умовами Програми, будь-якими застереженнями щодо отримання, зберігання, обробки та використання інформації, зазначеними в Політиці конфіденційності та захисту персональних даних на сайті apteka24.ua.</li>
                <li>Беручи участь в Програмі, кожен Учасник надає однозначну згоду на використання його імені, прізвища, фотографії або інших матеріалів про нього з рекламною метою, у тому числі право публікації його імені і фотографії у засобах масової інформації, будь-яких друкованих, аудіо- та відеоматеріалах, без обмеження території і строків такого використання. Таке використання не оплачується Організатором або будь-якими третіми особами.</li>
                <li>
                    <p>Учасник Програми надає однозначну згоду на те, що всі дані, в тому числі персональні, і дані про зроблені Учасником покупки можуть бути отримані, збережені, оброблені та використані Організатором та іншими уповноваженими Організатором організаціями та третіми особами без обмеження по терміну і території, в тому числі і за межами України, з метою реалізації Програми, створення нових програм лояльності, вивчення споживчого попиту в маркетингових, інформаційних, рекламних або інших аналогічних цілях, наданні Учасникові рекламних та інформаційних матеріалів без обмежень.</p>
                    <p>«Apteka24.ua» не несе відповідальності за шкоду або збитки, завдані учаснику або третім особам в результаті помилкового розуміння або нерозуміння умов даних правил, інструкцій або вказівок про порядок використання сайту, щодо розміщення даних та інших технічних питань.</p>
                </li>
                <li>Організатор залишає за собою право відмовити будь-кому в участі у Програмі за своїм розсудом, без будь-яких негативних наслідків для себе.</li>
                <li>Організатор має право в односторонньому порядку вносити зміни в дані Правила без попереднього повідомлення Учасників Програми.</li>
                <li>Учасник вважається проінформованим про призупинення або припинення дії Програми, а також про зміну Правил Програми, якщо такі зміни були розміщені на Сайті Програми та/або спрямовані Учаснику на зазначені в Обліковому записі адресу електронної пошти або номер мобільного телефону. Якщо від учасника не надійшла відмова від участі, то вважається, що він прийняв зміни. Обов'язок стежити за змінами покладається на Учасника.</li>
                <li>
                    Учасник програми лояльності «Морквинки» може відмовитися від участі в Програмі в будь-який час одним із таких способів:
                    <ul>
                        <li>подавши заявку на електронну пошту info@apteka24.ua;</li>
                        <li>звернувшись в службу підтримки клієнтів Організатора за телефоном 0800302244 та поінформувавши про своє бажання.</li>
                    </ul>
                </li>
            `
        }
    },
    loyaltyBonusRules: {
        title: `Правила нарахування та списання бонусів у програмі лояльності «Морквинки»`,
        bonusesAccrual: {
            title: `Нарахування бонусів`,
            list: `
                <li>
                    <b>Нарахування бонусів за відгуки.</b> Клієнтам нараховується винагорода в розмірі 30 бонусів за кожен їх відгук, який опубліковано на сайті та який відповідає наступним правилам:
                    <ul>
                        <li>відгук відповідає  <a href="${links.reviewsPostingPolicy}">Політиці публікації відгуків;</a></li>
                        <li>відгук на основі особистого досвіду, а точні фрази та зображення з відгуку не були опубліковані де-інде раніше;</li>
                        <li>об'єктом відгуку є конкретний товар, аптечна точка, стаття блогу і т.д., під яким(ою) даний відгук опубліковано;</li>
                        <li>кількість відгуків, за які клієнт отримав бонуси в поточному місяці, не перевищує 10 шт.;</li>
                        <li>бонус одноразово нараховується на баланс одночасно з публікацією його величини в розділі «Мої бонуси» відразу після модерації відгуку;</li>
                        <li>при блокуванні відгуку за порушення правил бонус може бути списаний з балансу учасника в будь-який момент.</li>
                    </ul>
                </li>
                <li>
                    <b>Нарахування додаткових бонусів за відгуки.</b> Клієнтам нараховується додаткова винагорода в розмірі 1 бонусу за кожну реакцію «Подобається» на їхній відгук, який опубліковано на сайті за такими правилами:
                    <ul>
                        <li>бонуси нараховуються не більше ніж на 5 реакцій «Подобається» на один відгук на добу;</li>
                        <li>загальна кількість додаткових бонусів за кожну реакцію «Подобається» на один відгук не може перевищувати 70 бонусів.</li>
                    </ul>
                </li>
                <li>
                    <b>Нарахування бонусів (кешбека) за покупку товару.</b> Клієнтам нараховується винагорода в розмірі 2% від вартості замовлення за покупку будь-якого товару на сайті apteka24.ua. Кількість бонусів, які повернуться клієнту, зазначено в картці товару спеціальною інфографікою:<br/>
                    <div class="bonus-cashback">
                        <img src="${links.images.yellowCarrotMini}" alt="bonus" /> Кешбек <span> 5.27 ₴</span>
                    </div>
                    <p>Нараховані бонуси (кешбек) стають доступні до списання після того, як замовлення, за яке вони нараховані, переведено в статус «Виконано». При скасуванні клієнтом замовлення або при відмові від замовлення при отриманні нараховані бонуси (кешбек) за дане замовлення буде анульовано.</p>
                </li>
                <li><b>Нарахування промокодів/купонів.</b> Клієнтам нараховується винагорода у вигляді промокодів і купонів у якості заохочення за участь в акціях, у спецпропозиціях від виробників і т.д., і являє собою одноразову знижку, безкоштовну доставку і т.д. Можливість використання промокодів і купонів обмежена за часом і вказана в особистому кабінеті клієнта.</li>
                <li>
                    <b>Нарахування welcome-бонусів за реєстрацію.</b> Клієнтам нараховується винагорода у вигляді: 
                    <ul>
                        <li>знижка 10% на перше замовлення, здійснене через мобільний додаток «Apteka24.ua»;</li>
                        <li>50 бонусів за реєстрацію за номером телефону в спеціальній формі на сайті apteka24.ua, якщо за цим номером телефону раніше не було покупок або реєстрацій на сайті apteka24.ua. Після введення номера обов'язково потрібно ввести код перевірки, отриманий клієнтом у повідомленні в Viber або SMS, інакше бонуси нараховані не будуть;</li>
                        <li>промокод на знижку 5% за вказаний email, якщо за вказаним номером телефону клієнта раніше були покупки або реєстрація на сайті apteka24.ua.</li>
                    </ul>
                </li>
                <li>
                    <b>Нарахування бонусів за фотоогляд («розпакування») товару.</b> Клієнтам нараховується винагорода в розмірі 30 бонусів за кожне їх «розпакування», яке опубліковано на сайті та відповідає наступним правилам:
                    <ul>
                        <li>відгук відповідає <a href="${links.reviewsPostingPolicy}">Політиці публікації відгуків;</a></li>
                        <li>відгук написано на основі особистого досвіду, а точні фрази та зображення з відгуку не були опубліковані ніде раніше;</li>
                        <li>об'єктом відгуку є конкретний товар, що реалізується на сайті apteka24.ua, аптечна точка, стаття блогу і т.д., під яким(ою) даний відгук опубліковано;</li>
                        <li>у відгук додано не менше 3-х фото в форматі .jpg, .png з розширенням не менше ніж 800х600;</li>
                        <li>забороняється публікація фото і зображень, які не мають інформаційної цінності або в неприйнятному вигляді (розмиті, перевернуті, дрібні і т.п.), або шокуючого характеру, а також скріншоти. Вказані публікації будуть видалені модераторами.</li>
                    </ul>
                </li>
            `
        },
        bonusesWriteOff: {
            title: `Списання бонусів`,
            list: `
                <li>
                    <p><b>Оплата бонусами.</b> Бонусами клієнт може оплатити до 50% вартості тільки тих товарів, які позначені на сайті спеціальним значком з морквинкою:</p><br/>
                    <div class="bonus-pay"><img src="${links.images.yellowCarrotLarge}" alt="bonus" /> або <img src="${links.images.yellowCarrot}" alt="bonus" /></div>
                    <p>Клієнт не може вибирати, яку суму бонусів витратити — списуються всі доступні до використання бонуси, але не більше 50% вартості товару. Використання бонусів виключає можливість одночасної оплати поточного замовлення за допомогою промокоду/купону.</p>
                </li>
                <li><b>Використання промокоду/купону.</b> При використанні промокоду/купону клієнт може отримати знижку на конкретний товар у замовленні, знижку на все замовлення, безкоштовну доставку і т.д. — в залежності від умов використовуваного промокоду/купону. Використання промокоду/купону виключає можливість одночасної оплати поточного замовлення за допомогою бонусів. Промокодом/купоном можна оплатити до 50% вартості замовлення. Якщо номінал купона більше 50% вартості замовлення, купон застосовується тільки на 50% вартості замовлення, а невикористана частина номіналу купона згорає.</li>
            `
        },
        limitations: {
            title: `Обмеження`,
            list: `
                <li>Не можна оплачувати бонусами замовлення, які сформовані на самовивіз із аптек-партнерів.</li>
                <li>Нараховані, але не витрачені бонуси, будуть згоряти через 180 днів від моменту, коли у користувача з'явиться можливість їх витрачати.</li>
                <li>Welcome-бонуси та інші бонуси з обмеженим терміном дії згорають після закінчення зазначеного для них терміну дії.</li>
                <li>
                    Адміністрація сайту має право:
                    <ol>
                        <li>заблокувати аккаунт за спам, некоректну поведінку, накрутку переглядів/рейтингів/репутації будь-якими способами (в тому числі за провокації на взаємне плюсування відгуків) або за грубі порушення інших пунктів правил;</li>
                        <li>анулювати бонуси, отримані клієнтами в результаті шахрайства та/або дій, що порушують дані правила;</li>
                        <li>вимагати необхідні матеріали для перевірки достовірності та правдивості інформації (включаючи фото об'єктів і документів);</li>
                        <li>не видаляти статті, відповіді та відгуки на вимогу авторів. Якщо Ви погодитеся з правилами та зареєструєтесь, а в майбутньому вирішите покинути проект, то всі Ваші публікації будуть залишатися частиною проекту;</li>
                        <li>змінювати дані правила з метою поліпшення якості сервісу, що надається із зазначенням дати внесених змін.</li>
                    </ol>
                </li>
            `
        }
    }
};
